<template>
	<v-container fluid>
		<v-row>
			<v-col cols="12">
				<h1 v-if="$vuetify.breakpoint.smAndUp" class="band-color-green interview-title">
					Day 6 - Los Angeles
				</h1>
				<h1 v-else class="band-color-green interview-title-sm">
					Day 6 - Los Angeles
				</h1>
			</v-col>
			<v-col>
				<p class="band-color-green word-salad">
					(The Art Of Being Overshadowed, The Captain Of Coal, Pandemonium: Absolute Pandemonium, Budapest Not Bucharest, Down In Tennessee, Something Fishy, This Big Hush, Number 24, Toronto Tragedy, A Change In Tone, Severe Shyness, Gogol’s Overcoat, Alien Knowledge, Dead Souls, More Freaks In A Circus, There’s Always The Next Book, The Meadows, 400 Million Broken Hearts, A Missouri Compromise, The Last Day, Taney County, Stale Goat Food, Not Your Average Psycho, Promoting The Guilty, Catching A Killer, How The End Always Is, Shadow On The Sun, A Stiff Hand, Lost Wages, A Sick Fuck, Up Pops The Devil, Call The Police, One Great Big Festering Neon Distraction, Delayed Departure, Green Felt Jungle, Pig Meal, Welcome To The Human Race, Balboa Island, Impossible Coincidences, Shaky Town, Satan’s Signature, Manhunter, A Kind-Hearted Canadian, Splitting Nines, Horrors Of The Holocaust, That Fateful Sunday, When Escape Is No Escape, Deboning The Juggernaut, Ghosts Of Glitter Gulch, Six The Hard Way, Descent Into The Filth, A Big Day For Justice, Empty Refrigerator, Trout-Focused Journalism, California Dreaming, Shark vs. Killer Whale, Souvenir Sickness, Coaching The Future, The King Of Oklahoma, Quiet Flows The Danube, Flying Into Immortality, Murmurs of Madness and more …… See Timeline for Synopsis of Events)
				</p>
			</v-col>
			<v-col cols="12" class="main-text text-border">
				<p class="h-l">
H.L. Well, it’s the last day. It is really the last day, as I cannot stay another one. Are you ready to wrap this up?
</p>
<p>
<span class="douglas">Douglas:</span> Yes, very much so. I am very excited to be almost finished! I know you can’t stay, and after today there will be nothing more to add.
</p>
<p class="h-l">
H.L. So, take a deep breath and let’s get started. You have the itinerary today.
</p>
<p>
<span class="douglas">Douglas:</span> Shouldn’t you explain to the readers what that means? Shouldn’t you tell them why we are still here?
</p>
<p class="h-l">
H.L. Like why I forfeited a day of fishing on this beautiful lake, a greater part of it at least, to be here? Only if you think we need to tell them.
</p>
<p>
<span class="douglas">Douglas:</span> Sure we have been forthcoming so far. Why not?
</p>
<p class="h-l">
H.L. No, it’s not that. It may be hard to lay it out without confusing them.
</p>
<p>
<span class="douglas">Douglas:</span> We can always edit it out.
</p>
<p class="h-l">
H.L. Alright. We were originally only scheduled for 5 days. This is what you requested of me. I have only five days in the summary you provided me, and therefore only five days worth of questions to ask.
</p>
<p>
<span class="douglas">Douglas:</span> But I asked you if there was any way we could extend this out to a sixth day. At first you said no.
</p>
<p class="h-l">
H.L. I did, as I liked what you presented, the timing and the balance; I did not see a reason to extend it out.
</p>
<p>
<span class="douglas">Douglas:</span> Yes, and we have been going round and round with this debate for almost six days now. Finally, you were kind enough to allow the trout some more days swimming freely in Lake Taneycomo unaware of your true intentions.
</p>
<p class="h-l">
H.L. Yes, and while I have been fishing every evening, I did have the entire day planned on the lake. But you said it was urgent, so here I am.
</p>
<p>
<span class="douglas">Douglas:</span> It is, and as you know, I have slept very little over the last two nights and have been working on the summary, which I will not give you until later.
<span class="break"></span>
You will understand the reason for this soon enough.
</p>
<p class="h-l">
H.L. So much ‘cloak and dagger’.
</p>
<p>
<span class="douglas">Douglas:</span> I know it probably seems silly, but when we get into the subject matter, you will understand why I have not discussed it with you.
</p>
<p class="h-l">
H.L. Nothing would surprise me at this point.
</p>
<p>
<span class="douglas">Douglas:</span> Unfortunately, this will.
</p>
<p class="h-l">
H.L. Should we begin with it then?
<p>
	<span class="douglas">Douglas:</span> Not quite yet. I have another request that you will find strange or at least unusual I am sure.
</p>
<p class="h-l">
H.L. And that is?
</p>
<p>
<span class="douglas">Douglas:</span> Well, after I disclose the subject matter we are going into, no one will be in the mood for a flowery or even a traditional ending. Therefore, could you ask me the questions, the ones we talked about that were supposed to go at the end of the interview now?
</p>
<p class="h-l">
H.L. Well that is different. Actually, I have no real problem with that. In other words you will just drop the readers off of the cliff at the end?
</p>
<p>
<span class="douglas">Douglas:</span> At the end all hell will break loose. It will be absolute pandemonium. Trust me on this. No one will care a word about what you say.
</p>
<p class="h-l">
H.L. Yes, you have made that clear. But to drop them off a cliff like that?
</p>
<p>
<span class="douglas">Douglas:</span> That really sounds sinister, especially the second time. They will have already fallen off the cliff by then.
<span class="break"></span>
I just know you worked really hard on these questions, and I did as well on the answers; so I just don’t want them to be overshadowed and quickly forgotten.
</p>
<p class="h-l">
H.L. That might be interesting; certainly it is unpredictable.
</p>
<p>
<span class="douglas">Douglas:</span> Thank you. And thank you for forfeiting most of your day fishing for this, I really appreciate it. I hope I don’t let you down.
</p>
<p class="h-l">
H.L. Are you ready?
</p>
<p>
<span class="douglas">Douglas:</span> Yes.
</p>
<p class="h-l">
H.L. This is unusual, but I will start.
<span class="break"></span>
Okay.
<span class="break"></span>
Now, I wanted to know what you had planned for your life next. You said something about a book. Do you plan on keeping your writing studio here in the Ozarks?
</p>
<p>
<span class="douglas">Douglas:</span> No, I will be leaving for somewhere before too long I imagine. There is too much in pain here, as I said before. However my ultimate goal is to be closer to my young children in Europe, while they are still somewhat young. Time is flying by.
</p>
<p class="h-l">
H.L. It does. And the book?
</p>
<p>
<span class="douglas">Douglas:</span> Oh yes. Well I have a book here; it is still half-unfinished, and I will continue working on that wherever I am at.
</p>
<p class="h-l">
H.L. That’s sounds pessimistic. How about I have a book half-finished! Not half-unfinished, it sounds like you will never complete it that way.
</p>
<p>
<span class="douglas">Douglas:</span> So true. Thank you, you’re right. I definitely plan on completing it.
</p>
<p class="h-l">
H.L. What is it about?
</p>
<p>
<span class="douglas">Douglas:</span> I’d rather not say. I will reveal this though: I have spent 25 years unintentionally elevating 3.5 billion women, through the discovery and ultimate publication of <span class="italic">The Theorem: A Complete Answer to Human Behavior</span>. So in the next book I am prepared to elevate men, to elevate mankind. It’s our turn.
</p>
<p class="h-l">
H.L. That’s good. I agree The Theorem elevates the female gender; it can be difficult for a man to accept. I will be interested to see how you pull that one off, though I think I have an idea.
<span class="break"></span>
And about The Theorem? Any hopes for that in the future?
</p>
<p>
<span class="douglas">Douglas:</span> Yes, this brings up a good point. If anyone is interested in this interview and wants to read more of my work, and is thinking about purchasing The Theorem, please hold off until the online version is available. The printed copies are so rough, and I make not a dime off of them. I would appreciate you waiting for the online version. It will be worth it. This I promise.
</p>
<p class="h-l">
H.L. When should they expect to see the online version?
</p>
<p>
<span class="douglas">Douglas:</span> It should be available by winter of 2020 or early 2021.
</p>
<p class="h-l">
H.L. You pushed that date back from what we talked about earlier in the week.
</p>
<p>
<span class="douglas">Douglas:</span> I did. I realize it is going to take me awhile to recover from this.
</p>
<p class="h-l">
H.L. I understand. I will look forward to the online version of The Theorem as well. I also wish you luck in your quest to be with your children. I really do.
</p>
<p>
<span class="douglas">Douglas:</span> Thank you.
</p>
<p class="h-l">
H.L. Since this is an interview, although instead it has become more of a lesson in recent American History, I should also inquire of some more personal aspects of your life.
<span class="break"></span>
Do you have a particular agenda or interest as an author or on a personal level you wish to forward?
</p>
<p>
<span class="douglas">Douglas:</span> Sure, I do.
<span class="break"></span>
I have three actually, though since spending too much time on all of them would be exhaustive, I will focus on the first.
<span class="break"></span>
My primary focus, and this is foreshadowing my next book, is improving the empathy and overall understanding between major religions in the world.
</p>
<p class="h-l">
H.L. Sounds like a big project.
</p>
<p>
<span class="douglas">Douglas:</span> Yes, and no. Certainly it is an important one. My primary interest is relations between Muslims, Christians and those of the Jewish Faith. But certainly I will not exempt Buddhism or Taoism and many other religions from the invite.
<span class="break"></span>
You know it is so critical to realize that The Theorem belongs to everyone, of every faith. These are the answers to who we are, to what motivates our every action. It is the reason we talk; we reproduce, the purpose of our sleep, and the origin of our dreams. It is the behaviors in the aggregate, and disorders of those behaviors in the specific. Again, this is a once in a civilization, once in a species discovery.
</p>
<p class="h-l">
H.L. I agree.
</p>
<p>
<span class="douglas">Douglas:</span> Therefore it is important to illustrate that the work does not belong to one country, one ethnicity or one religion. It just never will. No one can hold the patent or the trademark to all our behaviors, as this copyright belongs to each one of us.
<span class="break"></span>
It belongs to the small café owner of the Muslim faith in Cairo; and to the Jewish doctor in Tel Aviv. It belongs to the Christian cowboy in Wyoming, the Buddhist politician in Thailand, the Hindu hotelier in Goa and the Daoist teacher in Guangzhou. It belongs to all of us.
<span class="break"></span>
While I am a Christian now, I was not at the time of the Theorem’s discovery back in 1994. Looking back, I believe that is important; in fact I will say I believe it was mandatory because I can never attribute this work to one specific religion, one specific people. It has to be that way.
<span class="break"></span>
Sure, I am American, born in Las Vegas, Nevada; but that is nothing more than a curiosity. It is a title among people who do not really need titles. Ultimately, I am a citizen of the world; of our new world where boundaries are nothing more than an IP address, or a stamp in your passport. It just has to be this way.
<span class="break"></span>
So yes, this is what I want to focus on illustrating.
</p>
<p class="h-l">
H.L. That’s very powerful. The other two?
</p>
<p>
<span class="douglas">Douglas:</span> Yes, well the second is child abuse. We must stomp that out, it is the root of many of the evils in our society today.
</p>
<p class="h-l">
H.L. As witnessed here.
</p>
<p>
<span class="douglas">Douglas:</span> Yes, I think we have covered that from about every angle.
<span class="break"></span>
The third and final focus is a selfish motive; I believe writers and authors are terribly underpaid and very much exploited. This is especially true by the online retailers of books. This must stop.
<span class="break"></span>
While it is likely too late for me, I want a future generation of writers to be well compensated for their efforts. It is critical we see the quality of the human intellect advance, and financial incentive is certainly a logical way to foster that growth.
</p>
<p class="h-l">
H.L. All three are noble goals. Sounds like you are going to be busy. Do you ever think that might be too much?
</p>
<p>
<span class="douglas">Douglas:</span> I think The Theorem is too much for one person, at least this person; it was the story within the story, the subplot of the interview.
</p>
<p class="h-l">
H.L. I don’t quite understand.
</p>
<p>
<span class="douglas">Douglas:</span> Well the whole scenario is quite surreal.
<span class="break"></span>
There I am stumbling around the world, the uninformed messenger; I fall into this cabin in rural Tennessee and just so happen to write the world’s wealthiest people and gain their interest.
<span class="break"></span>
The government in response begins this massive cover-up and concealment operation. The ramifications then bleed into another presidential administration.
<span class="break"></span>
Some acid-washed version of Forrest Gump; it’s just all so bizarre.
</p>
<p class="h-l">
H.L. I love it, you hit it right on the head, ‘Forrest Gump 2: The Sequel’. I am going to use that, it’s non-negotiable!
</p>
<p>
<span class="douglas">Douglas:</span> I am glad you find my summation of my mental limitations entertaining.
</p>
<p class="h-l">
H.L. Oh, come on. You know I was just kidding. We are both tired, and that triggered something. All apologies if it bothered you. I know what you meant.
</p>
<p>
<span class="douglas">Douglas:</span> You sure?
</p>
<p class="h-l">
H.L. Yes, all of this from an out of print book; changing American History; you could not have scripted or arranged fate with any better precision. Isn’t that what you are saying?
</p>
<p>
<span class="douglas">Douglas:</span> Yes, as I said it is very surreal. It is almost as if I had no control over the events.
</p>
<p class="h-l">
H.L. What do you mean by that exactly?
</p>
<p>
<span class="douglas">Douglas:</span> Like one cold Tennessee morning, mixed with hickory ashes in the fireplace were the embers of discontent, some foreign force inside that just had enough of me. It wanted out.
<span class="break"></span>
The discovery had outgrown its host. So unknowingly but obediently, I compose <span class="italic">The Legacy Letter</span>. Unknowingly but obediently, I seek out the most powerful individuals in the world. So The Theorem is looking for a new home, all the while I think it is about me.
</p>
<p class="h-l">
H.L. I see. Implying The Theorem and the originating discovery has its own mind, is its own independent entity? Kind of like the movie Alien, it is tired of you so it rips out of your chest and goes to look for someone else to host it.
<span class="break"></span>
I never thought of that; but in a way, it is the story you just told, the one we just experienced here.
</p>
<p>
<span class="douglas">Douglas:</span> Yes exactly like that; a much better analogy than the first. With that said who can then blame me for running to the shelter of Christ or the safe harbor of The Church when events like those occur?
<span class="break"></span>
I got scared. I am only a man like all others. It took awhile, many years, but finally I got scared.
</p>
<p class="h-l">
H.L. No one can. Nobody will.
</p>
<p>
<span class="douglas">Douglas:</span> Now it belongs to the wealthy, The Theorem essentially belongs to the power elite. I am just going to sit along the route and do what the rest of the poor people do.
</p>
<p class="h-l">
H.L. What is that?
</p>
<p>
<span class="douglas">Douglas:</span> Watch the parade go by.
</p>
<p class="h-l">
H.L. At least you will have a good seat.
</p>
<p>
<span class="douglas">Douglas:</span> Yes, well I hope the parade starts soon. Because you know many of these wealthy individuals are getting up there in age, some of them have been with me for six years now and would really like to see The Theorem accepted and celebrated before they pass.
<span class="break"></span>
This is a big deal to a lot of people, and they want to be a part of it. They want to see this happen in their lifetime. So I hope the parade starts soon.
</p>
<p class="h-l">
H.L. I’m sure it will.
</p>
<p>
<span class="douglas">Douglas:</span> We will see.
</p>
<p class="h-l">
H.L. Other thoughts?
</p>
<p>
<span class="douglas">Douglas:</span> I am going to take a deep breath and tell you.
<span class="break"></span>
	Yes, I feel better.
</p>
<p class="h-l">
H.L. Yes, over the last week you were often pale and occasionally I noticed you shaking. I didn’t say anything, but you look better now. What a journey!
</p>
<p>
<span class="douglas">Douglas:</span> What a journey it has been. I think when you leave I am going to go outside and scream it. What a journey!  I feel better; I can’t believe today is the last day, finally we are almost finished.
<span class="break"></span>
This is such a personal victory regardless of the outcome. I know it will sound like an exaggeration, but I just realized that I have not been breathing properly for an entire year or maybe longer; this was welled up inside of me.
</p>
<p class="h-l">
H.L. I believe it, you will breathe better now.
</p>
<p>
<span class="douglas">Douglas:</span> Yes. But at the same time…
</p>
<p class="h-l">
H.L. At the same time what?
</p>
<p>
<span class="douglas">Douglas:</span> This leaves a mark on you. I was up much of the night thinking about it. It is such a lie, all the cheering and the victory laps; really I will never be the same after this. It was just so much for so long. It will define the rest of my life. It was a lifetime of events and pain in just six years.
<span class="break"></span>
Reliving it now, while helpful, makes me realize just how intense it all was. No one escapes from something like this unaffected; while it is a necessary lie you tell yourself all in order to get through it, still it’s a lie nonetheless. A part of me died during these events. While I can say it was a bad part, a good part to get rid of, in the end I have my doubts. They took something I can never get back. I see that now.
</p>
<p class="h-l">
	H.L. Having something so much out of your control define you is not something you ever really saw coming, I imagine.
</p>
<p>
<span class="douglas">Douglas:</span> No it wasn’t. You are right on that.
</p>
<p class="h-l">
H.L. That was heavy stuff this week, you did really good Douglas.
</p>
<p>
<span class="douglas">Douglas:</span> Well you should thank yourself, because the Tolstoy quote you read me the third day has stuck in my craw.
</p>
<p class="h-l">
H.L. So I won the contest after all?
</p>
<p>
<span class="douglas">Douglas:</span> Everyone wants to change the world, but no one thinks of changing himself. They are powerful words, from a great writer.
<span class="break"></span>
Yes you won; you beat me at my own game. There are no other writers in the world like the Russian Greats. As Dostoevsky said, we all came out of Gogol’s Overcoat.
</p>
<p class="h-l">
H.L. Is that why Gogol’s name is tattooed in Russian on your inner arm?
</p>
<p>
<span class="douglas">Douglas:</span> No I was not that forward thinking. It is probably just because I am a literature nerd and Russian Literature is likely tattooed somewhere on my inner soul.
</p>
<p class="h-l">
H.L. Interesting.
</p>
<p>
<span class="douglas">Douglas:</span> That went right over your head didn’t it?
</p>
<p class="h-l">
H.L. Obviously.
</p>
<p>
<span class="douglas">Douglas:</span> On my soul, my dead soul. That was the first book of Gogol’s I fell in love with. It was supposed to be a double entendre based on Gogol’s <span class="italic">Dead Souls.</span>
</p>
<p class="h-l">
H.L. I see. I think.
<span class="break"></span>
Well since you spoke of a quote I mentioned, I will return the favor and throw yours back at you. Being a self described, ‘Freak in the circus, who takes off his costume and rewinds his mind.’
In the end you are not planning on deserting us, I hope?
</p>
<p>
<span class="douglas">Douglas:</span> No, never. What you see is what you get. I have spent 25 years, now almost 26 years on this uneven trek to help humanity; I have no plans on deserting anyone now.
<span class="break"></span>
I am not suddenly going to take up another vocation, or tell you I have some other great calling. I am a writer and theorist, and this is what I will continue to do. I am a writer and wherever I am at this will never change. I may sail to Byzantium, but my direct focus will always be on humanity, on men and women and on women and men. That will never end.
<span class="break"></span>
People may have to be a little patient with me as sometimes my writing production is slower than it is for others, but I will get there. And everyone else will too.
</p>
<p class="h-l">
H.L. Well that’s good, it about wraps up the questions I had for you. Are you ready to start on the final section?
</p>
<p>
<span class="douglas">Douglas:</span> Really?
</p>
<p class="h-l">
H.L. Yes, really.
</p>
<p>
<span class="douglas">Douglas:</span> I don’t understand, you have five pages of questions there, and that is all you are going to ask me. I don’t get it.
<span class="break"></span>
What’s going on?
</p>
<p class="h-l">
H.L. Well, I don’t know how long your section is going to be, and I don’t want to run over on our time. We can’t run over.
</p>
<p>
<span class="douglas">Douglas:</span> Oh I see.
<span class="break"></span>
You know what this is really about. I should tell the reader’s but I won’t. I don’t want to jeopardize your professional credibility.
</p>
<p class="h-l">
H.L. I have no idea what you are talking about.
</p>
<p>
<span class="douglas">Douglas:</span> Are you sure about that?
<span class="break"></span>
Fine I will tell them then, even though I am sure you will not be brave enough to leave this in.
<span class="break"></span>
Okay, I live less than 10 feet from a private fishing dock and a series of boat slips. My tiny dumpy writing studio/apartment is literally right on the water. Now, for the entire morning, with every fisherman or family that walks by with fishing poles in hand; well, the expression on your face is priceless. You look like a sulking dog. I really wish I had a camera to capture that image.
<span class="break"></span>
I know you want to be fishing. So that is fine, the reader can learn more about my future plans another time.
</p>
<p class="h-l">
H.L. Is it that obvious?
</p>
<p>
<span class="douglas">Douglas:</span> Yes
</p>
<p class="h-l">
H.L. Every picture tells a story.
</p>
<p>
<span class="douglas">Douglas:</span> It is really true. So we will begin. Are you ready?
</p>
<p class="h-l">
H.L. Do you have to ask?
</p>
<p>
<span class="douglas">Douglas:</span> Good. That’s funny. We need a little humor. And as you would imagine we are going to go into some severely tragic events.
</p>
<p class="h-l">
H.L. The filth of the human heart?
</p>
<p>
<span class="douglas">Douglas:</span> As deep as you can go; to the bottom. So really, seriously, prepare yourself. I need you to be strong for me on this. Otherwise I will not get through it. And if I don’t do my job properly this isn’t going to make any sense.
</p>
<p class="h-l">
H.L. That’s fine. You can lean on me.
</p>
<p>
<span class="douglas">Douglas:</span> I may need to today. I think I hoped in some way you would try and talk me out of this more convincingly.
</p>
<p class="h-l">
H.L. How can I do that when I am not really sure exactly where you are going to go with this?
</p>
<p>
<span class="douglas">Douglas:</span> Sure, you’re right. I wasn’t thinking.
</p>
<p class="h-l">
H.L. I have an idea of which direction you are heading. You said it would be bad, and the rest of this has had some brutal content in there, so I am imagining the worst. Are you alright? You seem a little spaced out.
<span class="break"></span>
Of course we can leave it; we have plenty if you don’t want to go through with this.
</p>
<p>
<span class="douglas">Douglas:</span> No, this is what I wanted. Thank you again for staying.
</p>
<p class="h-l">
H.L. You have my undivided attention.
</p>
<p>
<span class="douglas">Douglas:</span> I will begin then.
</p>
<p class="h-l">
H.L. Begin. Please Begin.
</p>
<p>
<span class="douglas">Douglas:</span> Over the course of the past five days we have looked into some very disturbing events. We have seen how the intended and successful suppression of a discovery has created a myriad of problems for two presidential administrations, either directly or indirectly. With the exception of Barack Obama’s potential suicide attempt there is one topic we have primarily steered clear from and that topic is death.
</p>
<p class="h-l">
H.L. That is where we are going. That is what I thought. You foreshadowed that on the second day, but I let it go.
</p>
<p>
<span class="douglas">Douglas:</span> Avoiding death was intentional, as the interviews held their own weight; the events around the suppression certainly were seemingly fantastical enough, and I never thought to pollute that with the concrete reality of the seemingly natural process of the cycle of life.
</p>
<p class="h-l">
H.L. Sure, but death is a normal part of our existence. You can’t just ignore it.
</p>
<p>
<span class="douglas">Douglas:</span> No, you can’t. Not any longer at least.
<span class="break"></span>
While I have not mentioned death extensively it was always there, lingering around The Theorem all the way back to the beginning. First it was my grandfather in 1995; grandmother in 2000 and finally, almost ten years ago, my father. It was always there. While those are a few of my personal experiences with death, there were always other deaths as well; those less directly connected to me but still very close to the work, <span class="italic">The Theorem: A Complete Answer to Human Behavior</span> and its originating discovery.
<span class="break"></span>
When I sent out <span class="italic">The Legacy Letter</span> in 2014, I became more aware of man’s mortality. In some cases, I would send out <span class="italic">The Legacy Letter</span> to someone who appeared from my perception to be alive and well; only to be informed later that this person had indeed perished. This was embarrassing, as it made me feel amateurish or uncaring, as if I hadn’t read carefully enough their biography. I would quickly apologize for my insensitivity.
</p>
<p class="h-l">
H.L. I imagine that was embarrassing.
</p>
<p>
<span class="douglas">Douglas:</span> Yes definitely it was. But at the same time, as I said earlier, many of my potential donors were already up there in age to begin with, so it should have been expected; their advanced age and the years of responsibility related to earning and preserving that large amount of a fortune had taken its toll on their physical body. So again, I should not have been surprised.
<span class="break"></span>
Each death however, regardless of the circumstances, I took very personal. I had never attached this quality to death before. I am typically less likely than the average person to be affected by the death of an individual I do not know very well; this was my summation at least.
<span class="break"></span>
With <span class="italic">The Legacy Letter</span> however it was different. Because when I chose that person, when I found them, it was by utilizing all the unspoken perceptions and sensory guidance I had in me to seek them out; I was studying and researching a person very alive and vibrant, but when I would send it out to them, they were gone. They had vacated this plane for another.
</p>
<p class="h-l">
H.L. That makes sense, it would affect you.
</p>
<p>
<span class="douglas">Douglas:</span> Yes, it did, very much so; this was because I was inviting them into my life, into my reality, into my discovery. Then, like a thief, death came and took them away from me and away from my words. Therefore I started to dislike death, this intangible vapor that seemed to hover around the heads of many of my potential donors.
<span class="break"></span>
It was personal; death had set out to embarrass me, and like my affluent clientele, I did not like to be embarrassed. Therefore I did not like death. You see I was presenting heavy words, deep concepts and life changing themes. But what is more life changing than death? Nothing! Absolutely Nothing! So death was a competitor as well, and one I could never prevail over.
<span class="break"></span>
More than that, I found myself overreacting to the deaths of my potential donors. Suddenly I was that girl we all knew in school, the one who was so distraught and moved over the death of someone she barely knew about, and certainly had never met.
<span class="break"></span>
Death was something that was becoming adversarial to me personally.
</p>
<p class="h-l">
H.L. I see.
</p>
<p>
<span class="douglas">Douglas:</span> Well you may, I don’t know if I am expressing myself clearly. But essentially death was generating awareness in me in a way I had never experienced it before. So with each death I would take a closer look at the man or woman’s life. It was part of my mourning process I suppose. I would study like a scientist where death had snuck into their biography; where it first found its foothold, their vulnerability, and began to camp out in the shadows of this wealthy or powerful individual’s day. In a way, I became somewhat of an expert at this process; picking that moment, where the individual was in the process of living no more, but instead began the process of dying.
</p>
<p class="h-l">
H.L. Yes, having a large amount of money and responsibility can lead to a shorter life, as you say.
</p>
<p>
<span class="douglas">Douglas:</span> It can, though some of these individuals obituaries would prove you wrong, as others had a very long and prosperous life.
<span class="break"></span>
I explained a few days ago about how the detection tool I created gave me some limited insight into people’s behavior on the other end of my website. I focused on the celebrities; I said that some were visiting, the female celebrities, because they were pregnant. And then there were others that were older, often sick. Do you remember that?
</p>
<p class="h-l">
H.L. Yes, we covered it.
</p>
<p>
<span class="douglas">Douglas:</span> What I didn’t tell you though, was that there were deaths in there as well. I am talking of course about suicide. There were a few high profile suicides where the celebrity had been to my website weeks or months before they committed the fatal act. This bothered me deeply as you might imagine. You see in those cases I really felt that I had failed them. Perhaps my section on the website was not clear enough in relation to the origin of suicide. Did I not effectively convince them that suicide was nothing more than a senseless reenactment of birth?  Or perhaps my section on depression was not as convincing as it could have been. I really felt I let them down. Death was victorious and I was once again left behind to suffer my defeat.
</p>
<p class="h-l">
H.L. Well that is both logical and illogical. While it might be logical to have an enhanced feeling of sorrow in relation to that individual’s suicide, it is illogical to think that you could have prevented it.
</p>
<p>
<span class="douglas">Douglas:</span> Is it really illogical? I wonder. I really do. This was how I felt, the face of death was letting me know on a personal level it was time to change some things around. It was time to grow up, to quit being so flaky and indulging in my own pain. Death essentially made a man out of me, where everything else had failed; where the artistic temperament had allowed me to endure longer than usual in immaturity, I had finally found a reason for urgency. Expediency was my new motto. I had a new enemy, and needed new tools to combat it.
<span class="break"></span>
But death had many weapons in his arsenal; time was a big one, he could use time against me and against my people. Time was on his side, not on mine. I felt I was racing against him, racing against death. He was a serious foe, as I realized that youth and potentially investing in The Theorem were typically contradictory.
</p>
<p class="h-l">
H.L. We all race against death.
</p>
<p>
<span class="douglas">Douglas:</span> Yes but it was more than that, in this case at least. That is what I was trying to say. I felt that some of my potential investors, the ones most interested were gravitating somewhere around that cusp. It was a cusp between obtaining all the worldly knowledge one can acquire, before passing onto another realm.
<span class="break"></span>
It was as though, they were almost full. And The Theorem was in danger of filling them, answering the very questions that were keeping them hanging onto this world before they went to the next. That is what I am trying to express.
</p>
<p class="h-l">
H.L. That makes more sense, it’s very interesting. So you were working with a window of into the person’s life?
</p>
<p>
<span class="douglas">Douglas:</span> Yes, and in some cases it was a short window. But it is even more than that. Things are going to get stranger and more unusual, so prepare for it.
</p>
<p class="h-l">
H.L. This is already strange enough and morbid as well. I hope we are going to move onto something else.
</p>
<p>
<span class="douglas">Douglas:</span> You see that intangible vapor I spoke of earlier, this indefinable cloud of death that surrounded The Theorem and many of my elderly potential investors changed over the course of time.
</p>
<p class="h-l">
H.L. I don’t understand.
</p>
<p>
<span class="douglas">Douglas:</span> I mean it changed from an indefinable entity into a faceless image yes, but a materializing image nonetheless. Then it changed again, morphing from a faceless image to that of a face. Finally I realized it was a face I had seen before. While I hadn’t seen that face, I had seen what that face represented.
</p>
<p class="h-l">
H.L. I am totally lost now. A face?
</p>
<p>
<span class="douglas">Douglas:</span> Man, haven’t you been listening? I am trying to tell you that it was the face of a killer. A killer was hanging around the outskirts of my potential investors, around the fringes of what I was doing.
</p>
<p class="h-l">
H.L. A killer?
</p>
<p>
<span class="douglas">Douglas:</span> Yes, ultimately I realized that this wasn’t just any killer either, as it was a killer that worked in patterns and left signatures; he was committing serial murders. I realized that yes indeed, he was a serial killer.
</p>
<p class="h-l">
H.L. Really?
</p>
<p>
<span class="douglas">Douglas:</span> Yes! Yes. This is not something I would make up.
<span class="break"></span>
At first, I said I was tired. Maybe it was just delayed stress, maybe that or an overactive imagination; maybe, maybe, maybe…
But then I went back and slowly reviewed all the events of our Missouri home which occurred during the spring of 2016. From this safe vantage point, I meticulously pulled up each night.
<span class="break"></span>
I looked deeper, then deeper still into the hours before dawn. I would explore and review the events, each twist of the doorknob, each stalking and shadowy figure that walked past our windows. I quickly realized there was a contrast, a direct contrast between the precision of the executed presence of the governmental subcontractor and that of another.
<span class="break"></span>
This other shadow had deeper intentions, he pulled you into his intent where you could feel his sickness festering, manageably, but manifesting nonetheless.
</p>
<p class="h-l">
H.L. So the killer was close to you?
</p>
<p>
<span class="douglas">Douglas:</span> Of course I couldn’t be sure. I am speaking somewhat metaphorically here, but sometimes he seemed very close as if to get my attention. To let me know he would strike soon. He wanted me to watch his work, to watch for my potential investors as he was going to take one in the near future. Yes, he was there alright. I know it to be true, now as I say it.
</p>
<p class="h-l">
H.L. That is eerie.
</p>
<p>
<span class="douglas">Douglas:</span> Yes, it was.
</p>
<p class="h-l">
H.L. Now this is very interesting. So you really think you had a serial killer?
</p>
<p>
<span class="douglas">Douglas:</span> Yes, I knew I did. At the same time I couldn’t define who he was, but I could definitely feel the presence of a man.
</p>
<p class="h-l">
H.L. What about your web detection tool? Did that help?
</p>
<p>
<span class="douglas">Douglas:</span> Not at all, he was one step or many steps ahead of me. This was always the case in the beginning. I was way out of my league from the very start. I knew nothing about serial killers really. In fact, I didn’t even define him as a serial killer, just as a killer at that time.
</p>
<p class="h-l">
H.L. Was it politically motivated? Was he politically motivated, a part of the liberal elite as you say?
</p>
<p>
<span class="douglas">Douglas:</span> Well, I suspected he was hiding there and I was right; but he wasn’t interested in the policies of the Democratic Party, not at all. His motivations were something different altogether, much more sinister; he was someone different altogether.
</p>
<p class="h-l">
H.L. I love it! We are going on a hunt for a serial killer. Bravo Douglas, I like where you are going with this!
</p>
<p>
<span class="douglas">Douglas:</span> Well, don’t get too excited. Of course the back side of that is the human tragedy. And at the same time they are people I care about, and cared about deeply.
</p>
<p class="h-l">
H.L. Of course, I did not mean to be disrespectful.
</p>
<p>
<span class="douglas">Douglas:</span> No problem. But we are going to catch him. I only learned who he was a few weeks ago. And you are right; I will take you step by step on the catching of this serial killer, his motivations, and his childhood experiences that led finally to his need to kill. I will also take you through the three incidents or murders, as each incident had multiple victims.
</p>
<p class="h-l">
H.L. Just fascinating, I must say. I really had no idea this was how you were going to end the interview, but the hunt for a serial killer was way down the list.
</p>
<p>
<span class="douglas">Douglas:</span> Like I said, you study these wealthy individuals long enough and you learn a great deal about them. And like in any group, rich or poor, one out of 10,000 will be capable of something so unusual and remarkable. In this case, it is something very twisted and sick.
</p>
<p class="h-l">
H.L. So they are wealthy? They are someone you sent <span class="italic">The Legacy Letter</span> to? A billionaire?
</p>
<p>
<span class="douglas">Douglas:</span> Yes, they are someone who received a copy of <span class="italic">The Legacy Letter</span>. But I will not disclose whether they are a billionaire or not; at least not yet. But they have plenty of money, I can tell you that. Remember I sent <span class="italic">The Legacy Letter</span> out to many wealthy or successful individuals whose net worth wasn’t even close to a billion dollars.
<span class="break"></span>
This killer also only goes after the rich, as most of his victims are wealthy; many were even billionaires. He doesn’t seem to have any interest in killing the poor.
<span class="break"></span>
He is an elitist serial killer, if such a thing exists? He may be one of the first of this type in history. Certainly he will end up one of the most infamous ones.
</p>
<p class="h-l">
H.L. When did you find out about him? When did you realize that you may have been or were dealing with a serial killer?
</p>
<p>
<span class="douglas">Douglas:</span> Well, I was never fully sure, at least not until recently.
<span class="break"></span>
There are some unique qualities to our serial killer however. First, he is not necessarily impulsive. He is not a vision-oriented serial killer or hedonistic or even interested in power and control from the act itself. Among the classic categories; being a mission-oriented serial killer would best describe him, though that is not even a perfect fit.
<span class="break"></span>
Also, what differentiates him from other serial killers is that these are contract serial killings. In other words he does not actually participate in the physical act of killing. Therefore he will likely require photographs of the crime scene taken by the individual or individuals who actually executed the act. He also will follow the events closely in the media to reenact the thrill of the event.
</p>
<p class="h-l">
H.L. Are you sure then he is an actual serial killer?
</p>
<p>
<span class="douglas">Douglas:</span> Yes, I knew you would say that as well. At first like you, I had some doubts. But in one instance he staged the bodies after their death. In the other two he is leaving his signature by the victim types and groups.
</p>
<p class="h-l">
H.L. I see. Yes, sounds like a pattern or serial killer to me, those are classic traits.
</p>
<p>
<span class="douglas">Douglas:</span> He is, and his pattern is accelerating.
<span class="break"></span>
You know I would really like to have more time on this. I hate to rush it, for as you will soon realize these events are very close, one is less than 4 months old.  However as I stated, his trajectory is increasing in frequency, and he will likely strike again soon; if he hasn’t already. So again, time as it always is with death, is our enemy.
<span class="break"></span>
We need to expose him as soon as possible, or else witness the consequences.
</p>
<p class="h-l">
H.L. Yes, I can see why expediency is suddenly important.
</p>
<p>
<span class="douglas">Douglas:</span> Yes, it is an interesting scenario for sure. I still did not answer your question in regards to the exact date I was sure. That was for a reason. Because the exact date I realized that there was a serial killer responsible was related to the death I am going to cover here. Yet, I do not believe that the serial killer was responsible for this death; instead the Obama Administration, indirectly at least.
</p>
<p class="h-l">
H.L. I don’t quite understand. So we are going to look at another death, though not related to the serial killer?
</p>
<p>
<span class="douglas">Douglas:</span> Yes, out of respect to our victim we need to backtrack a bit. We need to cover his death.
<span class="break"></span>
Again, I wasn’t even going to bring him up at all, but I feel it would not be right to ignore the suspicious and tragic events around his demise. I can justify including him because we are covering the serial murders.
</p>
<p class="h-l">
H.L. I understand. So this individual meant a lot to you? It could be murder, not just a suspicious death.
</p>
<p>
<span class="douglas">Douglas:</span> To answer your first question, yes he meant a great deal to me, absolutely.
<span class="break"></span>
As far as your second question goes, it could have been murder of course. This was actually my first reaction or suspicion in regards to his death; though over time, the facts have not supported my initial assumption. Still, his death was very suspicious.
</p>
<p class="h-l">
H.L. We have been through so much over these six days, now a serial killer at the end of it all; and now an additional murder or suspicious death. I am concerned the reader will be overloaded.
</p>
<p>
<span class="douglas">Douglas:</span> They may be. I know it has been a lot to deal with. Did you expect less?
</p>
<p class="h-l">
H.L. No, no, of course not; keep going.
<span class="break"></span>
Okay, so who is it? Or who was it?
</p>
<p>
<span class="douglas">Douglas:</span> His name was Aubrey McClendon. Aubrey was killed in early March, 2016 when his SUV, which was traveling at 88 miles an hour, smashed right into a concrete pylon under an overpass in Oklahoma City.
</p>
<p class="h-l">
H.L. So why was that suspicious? I don’t understand.
</p>
<p>
<span class="douglas">Douglas:</span> Well, you might when you realize that the day before this ‘accident’, he was indicted by a federal grand jury for violating antitrust laws.
</p>
<p class="h-l">
H.L. Was he violating them?
</p>
<p>
<span class="douglas">Douglas:</span> Not from what I can tell, not from what many others could tell as well.
<span class="break"></span>
He was conducting business the same way and along the same standards as everyone else in that field; the energy sector. He was targeted. I saw the warning signs before it even happened. I sat there and watched helpless as I had done for the previous two years, with many other individuals. I watched the same pattern unfold for him. I realized increased web traffic from him reaching a crescendo not long before his indictment.
<span class="break"></span>
What made his case different however was his death. I felt they had gone too far, I just didn’t think the administration was capable of pushing a man over the limit like that.
</p>
<p class="h-l">
H.L. So he was very interested in donating or investing?
</p>
<p>
<span class="douglas">Douglas:</span> I certainly believe so. You know Aubrey McClendon was one of the first hundred or so Legacy Letters that I sent out. In many ways it was as though <span class="italic">The Legacy Letter</span> was written with him in mind.
</p>
<p class="h-l">
H.L. What do you mean?
</p>
<p>
<span class="douglas">Douglas:</span> His life was a storybook adventure seekers tale. He had the book smarts, a background in accounting and at the same time he had the heart of a wildcatter. I was very impressed with Aubrey McClendon and he knew it. I watched videos on him, I called him on a couple of occasions, and I may have even sent him a Christmas card in December of 2015, just a few months before he died.
<span class="break"></span>
You know earlier when you asked me why we moved to the Midwest and to Missouri; I didn’t give you the full answer for concerns of expanding beyond the immediate topic. But the energy sector was definitely a consideration in regards to that move.
<span class="break"></span>
As I said my initial focus was always Wall Street. But right after that was the energy sector, followed in third by the pharmaceutical industry.
</p>
<p class="h-l">
H.L. Sure.
</p>
<p>
<span class="douglas">Douglas:</span> After Tennessee, I obviously wanted to move to New York. I wanted to be a three or four hour train ride from the City. There I planned on introducing myself to the Hedge Fund Managers that I had spent the better part of that first year getting to know. My girlfriend at the time was having none of it. She had no interest in moving any further away from California. So we compromised on Missouri; I felt at least then we could be closer to Oklahoma and Texas where many of our potential investors were located.
</p>
<p class="h-l">
HL I see. I imagine it is hard to get a woman away from Southern California.
</p>
<p>
<span class="douglas">Douglas:</span> It is, especially when it starts to snow.
</p>
<p class="h-l">
H.L. Good point.
</p>
<p>
<span class="douglas">Douglas:</span> Now the reason I brought this up is because once we made that move, interest from Texas and Oklahoma began to increase. It rose on the backs of great leaders in the field like Aubrey McClendon, a billionaire who had co-founded Chesapeake Energy.
</p>
<p class="h-l">
H.L. I have heard of Chesapeake.
</p>
<p>
<span class="douglas">Douglas:</span> Yes, many have. At one time they were the second largest producer of natural gas in the U.S. They were right behind Exxon Mobil.
</p>
<p class="h-l">
H.L. False charges?
</p>
<p>
<span class="douglas">Douglas:</span> They really were. They accused him of fixing the price of land to pay less for it; this, when everyone else said he actually overpaid for the price of land. It made no sense.
</p>
<p class="h-l">
H.L. No it doesn’t.
</p>
<p>
<span class="douglas">Douglas:</span> But the Obama Administration had him good, as far as scare tactics. You know they throw false charges at you, and even though you can disprove them, by that time all your investors run for the hills. It is a mess. It was Obama targeting 101!
They waved the potential of prison in front of his face, all this to a pillar in the community and a generous philanthropist.
</p>
<p class="h-l">
H.L. That’s not right.
</p>
<p>
<span class="douglas">Douglas:</span> And the death itself did not make any sense either. For one thing there was no suicide note. Sure you have to think about a suicide staged to look like an accident; maybe for an insurance payout. But men like Aubrey McClendon are almost always worth more alive than dead. He could have made whatever his insurance policy would have paid out in a week, just sitting at home in his easy chair picking stocks on the market. He was highly talented.
</p>
<p class="h-l">
H.L. And as far as it being an accident?
</p>
<p>
<span class="douglas">Douglas:</span> Well the timing looks bad, it really does. More bad luck for the administration, and more bad luck for Barack Obama. Like those around him who didn’t believe it was suicide, which I agree with, I also do not buy the accident theory. I will not go into details, but your readers can look it up, they will see what I mean.
</p>
<p class="h-l">
H.L. Your theory?
</p>
<p>
<span class="douglas">Douglas:</span> Well I have two main theories on his death, neither one is very strong but I will put them out there just in case someone has some information and is shy about releasing it.
</p>
<p class="h-l">
H.L. Sure.
</p>
<p>
<span class="douglas">Douglas:</span> Well the weakest theory is an accident of course, the official story. In that case I still blame the Obama Administration. They should have never targeted him. He was so upset that he lost his train of concentration and crashed.
</p>
<p class="h-l">
H.L. But you’re not buying it.
</p>
<p>
<span class="douglas">Douglas:</span> No, not at all. I am not buying what they are selling. You see they really piled it on Aubrey McClendon. He was smart too, and he was very intuitive. In many ways he was similar to me. He could see patterns; I think Aubrey, unlike many others who were harassed, realized it was due to his interest in The Theorem. I also know he was an exceptionally brave man, very brave. I think he threatened to expose the Obama Administration.
</p>
<p class="h-l">
H.L. You think he connected the dots?
</p>
<p>
<span class="douglas">Douglas:</span> I really do. Remember this is March 2016. As I said, by then almost everyone knew they were using The Theorem and <span class="italic">The Legacy Letter</span> to target my potential donors. It is possible Aubrey McClendon did his homework on the issue and was going to expose the administration for their corruption.
<span class="break"></span>
Now even if his case was flimsy, even speculative, this could have started the ball rolling. In other words, other potential investors who were targeted could start coming forward connecting the dots together.
</p>
<p class="h-l">
H.L. This would or could have then started a snowball effect.
</p>
<p>
<span class="douglas">Douglas:</span> Yes, so in response, someone went after Aubrey to keep him from talking.
</p>
<p class="h-l">
H.L. Who?
</p>
<p>
<span class="douglas">Douglas:</span> Someone away from The White House. I would look at Bill Clinton. After all that is his territory down there. I don’t think it was Obama, not at all. But I could see or at least feel an old Arkansas associate of Clintons coming out of retirement to take that job. That was my first guess, but it was only a guess and didn’t really hold water.
</p>
<p class="h-l">
H.L. That is who I was thinking of. Is Bill Clinton the serial killer?
</p>
<p>
<span class="douglas">Douglas:</span> No, not at all. You are barking up the wrong tree there. That would be quite a story though. Sounds really more like a movie, a blockbuster. A president leaves office, becomes bored and then becomes a serial killer.
</p>
<p class="h-l">
H.L. Yes, it would be a blockbuster movie for sure.
</p>
<p>
<span class="douglas">Douglas:</span> Of course you would have to deal with the fact that they have Secret Service with them all the time. No that is just fantasy. Because as you will see, we are heading out way out of the league, far past Bill Clinton’s pain levels and childhood exposures that define this serial killer.
</p>
<p class="h-l">
H.L. Maybe someone ran him off the road or did something to his accelerator.
</p>
<p>
<span class="douglas">Douglas:</span> Sure, it is possible.
</p>
<p class="h-l">
H.L. It is.
</p>
<p>
<span class="douglas">Douglas:</span> I should also add that it may not be either of those factors that led to his death. As I began to research this, other names mysteriously started popping up on my detection tool. They were names within the industry. And these names came on my search and even on my feed fast and heavy, very heavy. And they didn’t belong there. In other words someone was watching me research Aubrey McClendon, and they seemed to be getting nervous.
<span class="break"></span>
Perhaps, as much of a maverick as Aubrey McClendon was, he may have been prepared to expose others. Though to me that shoe doesn’t fit his personality. Or others feared that he might expose them, and did away with him.
</p>
<p class="h-l">
H.L. That actually seems the most logical to me.
</p>
<p>
<span class="douglas">Douglas:</span> Maybe.
<span class="break"></span>
Maybe not.
</p>
<p class="h-l">
H.L. We are heading into some dangerous territory here Douglas.
</p>
<p>
<span class="douglas">Douglas:</span> Yes, we are.
</p>
<p class="h-l">
H.L. Are you alright?
</p>
<p>
<span class="douglas">Douglas:</span> Yes, as you can see it affected me deeply, but there is something else that I need to tell you.
</p>
<p class="h-l">
H.L. What is it?
</p>
<p>
<span class="douglas">Douglas:</span> Well, I said a few days ago that I stopped sending out <span class="italic">The Legacy Letter</span> in late February of 2016; do you remember?
</p>
<p class="h-l">
H.L. Yes, you said it was because of the election. I feel that was before we lost our innocence though, I have to admit.
</p>
<p>
<span class="douglas">Douglas:</span> Yes, well murder or even suspicious deaths have a tendency to do that.
<span class="break"></span>
Anyways, I was only originally planning on taking a short break. I was going to return to sending out copies from April to at least June in 2016.
</p>
<p class="h-l">
H.L. And this death was the reason you never resumed?
</p>
<p>
<span class="douglas">Douglas:</span> That is correct, it really affected me. And obviously still does.
</p>
<p class="h-l">
H.L. Obviously.
</p>
<p>
<span class="douglas">Douglas:</span> To rub salt on the wound, Barack Obama promoted William Baer, the U.S. Assistant Attorney General who orchestrated this judicial fallacy against Aubrey McClendon to the position of Associate Attorney General. This all happened just a month after the accident and subsequent death of Aubrey McClendon.
</p>
<p class="h-l">
H.L. Unbelievable. Like you said, you can’t make this stuff up. I am really starting to see what you meant by that statement.
</p>
<p>
<span class="douglas">Douglas:</span> Yeah, it’s like; congratulations, you are indirectly responsible for a man’s death. Here, have a promotion. It is sick and twisted.
</p>
<p class="h-l">
H.L. That is not right. But of course in politics you have to sometimes reward those who know too much. Likely he was not going quietly either.
</p>
<p>
<span class="douglas">Douglas:</span> That is true. Well that wraps up our non serial killer related death. Obviously I am very sorry to his family, if <span class="italic">The Legacy Letter</span> or The Theorem was even indirectly connected as cause and effect to his death. He was a great man and I am sure he is missed.
</p>
<p class="h-l">
H.L. The next one?  This next one will be the first murder you connect to the serial killer?
</p>
<p>
<span class="douglas">Douglas:</span> Correct. I believe that you will have heard of these murders; Barry and Honey Sherman in their Toronto, Ontario, Canada home on December 13, 2017.
</p>
<p class="h-l">
H.L. Of course I have. It was a big case. In fact when you talked about deaths, even before you brought up murders, I was going to inquire about that couple.
<span class="break"></span>
So they received <span class="italic">The Legacy Letter</span>?
</p>
<p>
<span class="douglas">Douglas:</span> Of course; Barry Sherman did. In fact he was one of the first we sent it out to. I say we, because for the first couple of weeks my girlfriend at the time helped me. It was her idea of sending it out to the owners of pharmaceutical companies. I was in disagreement with that idea, as I didn’t think it would be a fit. Obviously I was wrong.
<span class="break"></span>
Then later, in February of 2017, ten months before the deaths of The Shermans, I sent a Legacy Letter to Dr. Jeremy Desai. Dr. Desai was the CEO of Apotex, the pharmaceutical company Barry Sherman owned at the time of his death. But this is just the beginning. Because according to my detection tool, Barry Sherman visited my site the month before him and his wife were murdered. And someone from his company, Apotex, also visited The Theorem Website in November. In fact Barry Sherman was one of my top visitors from pharmaceutical companies in Canada during early November of 2017.
</p>
<p class="h-l">
H.L. So do you think he was going to invest, or donate?
</p>
<p>
<span class="douglas">Douglas:</span> Obviously I have no idea. I wish I knew. But I will say this; Barry Sherman was planning on giving a substantial portion of his money away near the time of his murder. So who knows?
<span class="break"></span>
Now in the next two cases, along with the last we just spoke of, these individuals all received a copy of the letter very early on. Now this is important for a couple of reasons.
<span class="break"></span>
The first is that it takes a long time to realize the impact not only of <span class="italic">The Legacy Letter</span> but also The Theorem itself. Barry Sherman may have put <span class="italic">The Theorem: A Complete Answer to Human Behavior</span> on his reading list, and that could have taken a year to get to. Then he would have to realize the effectiveness of the model in action, to watch it unfold in front of him. Then, there are the philosophical implications of a discovery of this magnitude occurring for one to even witness. The list goes on and on, but ultimately it takes time to wrap your head around the concept of The Theorem, no matter how talented and bright you are. And Barry Sherman was certainly very talented and bright.
</p>
<p class="h-l">
H.L. Sure.
</p>
<p>
<span class="douglas">Douglas:</span> Then of course if he was interested, he would have to plan on allocating his investment or his funding into his schedule. As often these wealthy individuals plan a couple of years in advance as to who will receive the money they plan on giving.
<span class="break"></span>
Of course I didn’t realize any of this in the beginning. I am telling you this because I learned it the hard way. Just because I was ready to receive the money, did not mean they were ready to give it at that moment. Obviously in the beginning I was very naive to the process and I did not understand this.
</p>
<p class="h-l">
H.L. More knowledge you have earned; the other reason?
</p>
<p>
<span class="douglas">Douglas:</span> The other reason is that the early date they received <span class="italic">The Legacy Letter</span> could have been seen as bragging rights by the potential donor. Most billionaires are extremely competitive, especially against other billionaires. So, to receive it earlier they would have assumed they were favored over their peers and competitors.
</p>
<p class="h-l">
H.L. Especially if the CEO of the company he owned received a copy earlier in 2017, close to three years after Barry Sherman received his Legacy Letter.
</p>
<p>
<span class="douglas">Douglas:</span> Certainly, and if the CEO was interested that would have been even better. No matter, even if not, it may have served as reminder to Barry Sherman about the letter he received from me years before.
</p>
<p class="h-l">
H.L. Interesting. Do you want to explain the events surrounding their murder?
</p>
<p>
<span class="douglas">Douglas:</span> Sure. At the time of their murders, The Sherman’s were in the process of selling their home. So on December 15, 2017, a real estate agent entered their Toronto home to show some prospective clients their property; this utilizing a lock box that had been previously installed. When they entered the pool room, they found both Barry and Honey Sherman dead; their necks were restrained with leather belts to a metal railing above the pool deck.  Barry was seated and his wife was laying down, both with leather coats pulled over their shoulders.
</p>
<p class="h-l">
H.L. Posed?
</p>
<p>
<span class="douglas">Douglas:</span> Absolutely. This is a very personal murder as you will see, but I will continue with the reaction.
<span class="break"></span>
Initially the police called it a murder/suicide. But it was obvious to the grown Sherman children that such a verdict was not consistent with their parents’ state of mind, or even the facts of the crime scene. Therefore they hired a team of private investigators and the children’s suspicious were confirmed; it was indeed murder.
</p>
<p class="h-l">
H.L. Never solved?
</p>
<p>
<span class="douglas">Douglas:</span> No it has not been. Here he will take a look at the killer’s motivations. We will go into this now, even though I am not ready to release the killers name; this because after we get into the final murder likely as I said it will be chaotic and no one will remember what I am about to disclose.
</p>
<p class="h-l">
H.L. I don’t quite understand, but go ahead.
</p>
<p>
<span class="douglas">Douglas:</span> Well when I say this murder was personal I may have misspoke. I mean the murder was symbolically personal. In other words, these bodies were indeed staged as you suspected. Essentially this is our serial killer symbolically killing off his both his mother and father; the father is sitting in the chair and the mother is laying down, submissive to the father’s commands. Here the sick child who is now a grown man, has had his parents placed in a position where he wants them to listen to him. He is punishing them not only for their yet undiscovered offenses, but also for the fact that they never listened to him.
</p>
<p class="h-l">
H.L. His father was a monster and his mother did nothing to stop him; she just lays there?
</p>
<p>
<span class="douglas">Douglas:</span> That is it. Also what is important to realize Barry Sherman’s religious beliefs; while he grew up in the Jewish Faith, he was personally an atheist.
</p>
<p class="h-l">
H.L. Was it anti-Semitic?
</p>
<p>
<span class="douglas">Douglas:</span> No, more like the opposite. But we are jumping ahead.
</p>
<p class="h-l">
H.L. And you feel The Theorem was involved?
</p>
<p>
<span class="douglas">Douglas:</span> I very much do. Again, this is a very unique murder. Our killer is a highly organized and extremely successful man. And like so many men who are successful, he has a great amount of pain inside; certainly he has more pain than anyone we have met over these six days. So he is looking to act economically, these murders likely served two purposes.
<span class="break"></span>
The first was the purpose he could sell to others on the inside, though very few likely know about this, but those that are still alive to tell about it at least. This purpose would have to suppress The Theorem. To the outside, it was to send a message to potential investors or donors of The Theorem that this can happen to you.
<span class="break"></span>
The second purpose is of course more personal. He can rid himself of the haunting memory and demons of his childhood by symbolically slaying his parents; both dad and mom. Of course the relief is only temporary and he is going to begin to relish his perceived omnipotence of playing God to these innocents.
<span class="break"></span>
He has found a format in targeting The Theorem he likes. He can justify the murderous thoughts he has by filtering them through the necessity for political means or unrelated emotional needs. This way he doesn’t have to accept that he has a need to kill, he doesn’t have to drink that medicine straight; he can mix the medicine with some sweet elixir before he digests his actions into his subconscious. Suppression of The Theorem is that sweet elixir.
</p>
<p class="h-l">
H.L. Convincing. There is so much truth in something that you mentioned earlier. If we have not learned anything else in these six days, it is how the wealthy, the highly successful succeed.
<span class="break"></span>
While we all have pain inside of us, often debilitating amounts, these characters are different. They parallel the release of their pain with successful accomplishments. They only go into a deal if it checks all the boxes. This way, as you say, they can conserve energy.
</p>
<p>
<span class="douglas">Douglas:</span> Yes, because remember to live in the past like that, to have every thought derailed into your horrific childhood conscious experience takes a large amount of energy. So they are very effective in not wasting any opportunity to accomplish multiple tasks with one action. Our serial killer is no exception.
</p>
<p class="h-l">
H.L. Also the fact that the murders occurred in the middle of December that could have provided additional disincentive; being the ‘giving season’ as you said.
</p>
<p>
<span class="douglas">Douglas:</span> Honestly, I never connected the time of year to the murders. But you are right. That makes sense. It does strengthen it.
</p>
<p class="h-l">
H.L. I think so.
</p>
<p>
<span class="douglas">Douglas:</span> Obviously it is very painful to go into these events. So I am sure I just blacked out many of the events surrounding these murders.
</p>
<p class="h-l">
H.L. I imagine it is painful. Yes.
</p>
<p>
<span class="douglas">Douglas:</span> I can feel that there is more. I know there is more, but every time I begin researching all that happens is that I find more supporting evidence. And each time I end up in a bucket of my own tears. I am not trying to gain sympathy here, but just imagine. Just imagine the possibility of being responsible for this either directly or indirectly.
</p>
<p class="h-l">
H.L. I can’t imagine. Like you said, it’s like watching a scary movie with your hands over your eyes. The truth is too brutal to realize and impossible to accept.
</p>
<p>
<span class="douglas">Douglas:</span> Yes, it is. I don’t know if it is one of the killer’s intentions to destroy me as I investigate this, but he is certainly doing one hell of a job at it. I can only take so much.
</p>
<p class="h-l">
H.L. I don’t quite know what to say to that.
</p>
<p>
<span class="douglas">Douglas:</span> There is nothing you can say.
<span class="break"></span>
I will say this however. Of all the murders or ‘accidents’ that I researched, I realized the most reciprocal web traffic on this one.
<span class="break"></span>
In other words, when I looked into news stories related to The Sherman Murders, I received a tremendous amount of web traffic back from those individuals surrounding the events. It is important to remember, I never search masked; I am always identifiable.
<span class="break"></span>
Now there could be a logical explanation for this reciprocal web traffic. As it is an active murder investigation and likely the authorities are monitoring any searches related to the events, hoping the killer will somehow show his face, or relive his glory digitally.
<span class="break"></span>
On other hand it could be that the Sherman’s were indeed considering investing in The Theorem, but that fact by itself, without this interview and the narrative we are disclosing, would not justify a clue considered worth pursuing by them at this point.
</p>
<p class="h-l">
H.L. That will soon change. The next murder?
</p>
<p>
<span class="douglas">Douglas:</span> Yes, I just wanted to add one thing. Of all the men I studied, most were highly intelligent. Barry Sherman however was beyond that; he was brilliant, in an exceptional way. I just thought out of fairness I should add that. It is important he be remembered that way.
</p>
<p class="h-l">
H.L. I can see he was, what little I read about him supports that.
</p>
<p>
<span class="douglas">Douglas:</span> Yes, well the next murder is the weakest link of the three.  I would not even include except for one fact.
</p>
<p class="h-l">
H.L. What is that?
</p>
<p>
<span class="douglas">Douglas:</span> It is very similar to the third incident; murder.
</p>
<p class="h-l">
H.L. Yes, you should include it then.
</p>
<p>
<span class="douglas">Douglas:</span> Oh, I was going too. His name was Christopher or Chris Cline. He was a coal magnate and billionaire. He died in a helicopter crash with his daughter off of his private island in the Bahamas on July 2019.
</p>
<p class="h-l">
H.L. I have also heard about that one. You think that was murder as well?
</p>
<p>
<span class="douglas">Douglas:</span> Oh yes. Most definitely, I believe it was sabotage of some sort.
</p>
<p class="h-l">
H.L. That is a long time between murders.
</p>
<p>
<span class="douglas">Douglas:</span> Yes it is. However these may not be the only murders the killer committed during that time frame. Again, we are only focusing on murders directly related to The Theorem and to <span class="italic">The Legacy Letter</span>. This individual, our killer, has worldwide interests.
</p>
<p class="h-l">
H.L. Chris Cline received a Legacy Letter and was interested in investing?
</p>
<p>
<span class="douglas">Douglas:</span> Yes, to both I believe. It is a similar pattern of interest as with Aubrey McClendon. He was sent his copy of the letter, very early on. I spent an exhaustive amount of time researching him and his life. Again, I made no attempt to conceal that; therefore he would have known I was very interested in him. One of the reasons I put such emphasis on Chris Cline obviously was geography. He was born in West Virginia about 250 miles from where we were living in Tennessee at the time. Many of the billionaires like to have a regional emphasis on where they spend their philanthropic dollars. So I felt there was a good chance with him. Also he had studied psychology in college.
</p>
<p class="h-l">
H.L. Sounds like he was the ideal candidate.
</p>
<p>
<span class="douglas">Douglas:</span> He really was. Also his coal operations were in Illinois and his headquarters of his Company; Foresight Energy was located in St. Louis, Missouri. So our move to Missouri could have been seen as a move closer to his operational hub. Christopher Cline was a risk taker, and <span class="italic">The Legacy Letter</span> was tailored especially to someone with his personality in mind.
<span class="break"></span>
To make all of this even more painful, Chris Cline was one of my favorites. While I like most all of the billionaires, some more than others, Chris Clines story was one that I returned to over and over again. Maybe it was because we were living in Tennessee, maybe it was a number of things, but his life certainly never stopped inspiring me. This is why it is too painful to go into too much detail in regards to his life and his multitude of accomplishments.
</p>
<p class="h-l">
H.L. Sure, everyone has their favorites. Was he interested in investing though?
</p>
<p>
<span class="douglas">Douglas:</span> That is a difficult question to answer. It was hard to detect Chris Cline’s interest. He would come and go off my detection tool over the years. I believe I called his company a few times and again he very likely received a Holiday card from me in 2015. So honestly, it is hard to give you an exact answer as to whether he was interested in 2019 or not. In some ways I think his interest was exaggerated by the killer.
</p>
<p class="h-l">
H.L. What does that mean?
</p>
<p>
<span class="douglas">Douglas:</span> Well our serial killer has a definitive audience in mind he is trying to impress.  He is putting on a show for someone, and that person is not me. He is showing this person, his small audience of one that he can handle his problem; a major problem of his audience is <span class="italic">The Legacy Letter</span> and The Theorem.
<span class="break"></span>
At the same time he needs this murder. This is a practice run for his magnum opus, which we will go into later. This is hard to talk about, it is really sick. This killer is really not well. And truthfully I feel I am getting unstable talking about him.
</p>
<p class="h-l">
H.L. That‘s okay take a minute.
</p>
<p>
<span class="douglas">Douglas:</span> I’m fine. So yes, he needs for this to happen. Our serial killer is going to start or at least continue applying his signature to this crash; as there will be a father and daughter on board.
</p>
<p class="h-l">
H.L. What do you mean continue? Were there other crashes?
</p>
<p>
<span class="douglas">Douglas:</span> I believe that there is one other that I know about, but it is out of the direct scope of The Theorem, so I won’t go into it.
</p>
<p class="h-l">
H.L. About Christopher Cline’s crash?
</p>
<p>
<span class="douglas">Douglas:</span> Yes, such a senseless and tragic group of deaths. On July 4, 2019; Chris Cline, his 22 year old daughter and five others were killed when a helicopter owned by a company of Clines took off from Grand Cay, Bahamas enroute to Florida for emergency medical treatment. Witnesses said that right after takeoff the helicopter began to spin out of control and crashed shortly thereafter.
</p>
<p class="h-l">
H.L. Do you think the killer is saying something here, to the fact that the ‘accident’ is on July 4?
</p>
<p>
<span class="douglas">Douglas:</span> Yes, he wants an American audience; he wants one particular American to know this is for him. For this American, July 4th will be of special importance. But that importance will reveal itself later.
</p>
<p class="h-l">
H.L. You would think that if the pilot knew he was going to be flying the boss, Chris Cline, then he would double check everything. It would be the same for the mechanics.
</p>
<p>
<span class="douglas">Douglas:</span> I absolutely agree with you. Like with any company, special care goes into preparation for when the owner is onboard, it is just common sense.
<span class="break"></span>
You know, your chances of dying in a helicopter crash are very minimal; it is safer than driving. However accidents happen all the time, and billionaires and the ultra wealthy will be riding in helicopters substantially more than the average person.
<span class="break"></span>
But at the same time there were two pilots on board, so you would think you could rule out medical emergency by the pilot as a reason for the crash.
</p>
<p class="h-l">
H.L. I imagine so.
</p>
<p>
<span class="douglas">Douglas:</span> Add that to the fact that according to my detection tools either the killer or someone very close to him; someone who works with him visited my website less than 35 days before the event. This was no accident.
</p>
<p class="h-l">
H.L. This is getting hard, and the last?
</p>
<p>
<span class="douglas">Douglas:</span> Well, it is only going to get more tragic from here, although I don’t know if you can ever specify degrees. Every one of these men and women’s lives are of the utmost importance. Though as we will see, this next individual was loved by millions.
</p>
<p class="h-l">
H.L. It is bad already. I can’t imagine it getting any worse.
</p>
<p>
<span class="douglas">Douglas:</span> Well first, I would like to apologize to all of the families. While it should go without saying, I will say it anyways.
<span class="break"></span>
If I ever thought that death, these deaths and others would originate from <span class="italic">The Legacy Letter</span>, I would never have composed it nor would I have ever sent it out. On that Tennessee morning I would have started on something altogether different if I realized that this much pain could ever derive from something I believed to be so good and so pure. I am deeply sorry for your loss.  This apology extends to all the families who lost loved ones, including the families of our next victims.
</p>
<p class="h-l">
H.L. That was very nice. I am sure they realize that you had no idea any of this would be connected.
</p>
<p>
<span class="douglas">Douglas:</span> Maybe they do. Maybe they don’t. The mourning process can be a very confusing and uneven endeavor though.
<span class="break"></span>
Okay there is no sense putting off the inevitable. Here in this final incident; in this final accident, this final murder, the killer will pull out all the stops. He has graduated to master status. For what he will accomplish next will elevate him into the ranks among the great serial killers of all times. This is his masterwork, his signature collection; this is his magnum opus, his immortality.
<span class="break"></span>
Here, his audience is not just Douglas Arone, a former president or even The Pope. Instead his intended audience is the world. Perhaps I have been kept alive long enough to tell his story, though I doubt I will tell it the way he wishes. But, I will tell it nonetheless.
<span class="break"></span>
To understand the killer’s motivations we must return to events we covered yesterday.
<span class="break"></span>
We must return to the events of the twenty-third day of January 2020. Yesterday, you asked me if I thought the significance of the importation of the Corona Virus on January 23rd was for my eyes or for the eyes of Pope Francis.
</p>
<p class="h-l">
H.L. Yes, I remember. You said they were obviously for the eyes of The Pope.
<span class="break"></span>
This was so that every time he opened up the letter he had to look at the envelope and the date on that envelope would match the established or reported date the Corona Virus (COVID-19) hit Italy.
</p>
<p>
<span class="douglas">Douglas:</span> Yes, that is correct. But there is another more logical reason it was for The Popes eyes, this date.
<span class="break"></span>
After all, why am I going to be interested in the news on the 23rd of January? My letter cannot defy space and time and land on The Popes desk that very day I sent it. If it was an email it could, but this one was not. No, as we have seen the letter I sent, this second correspondence was typed out. It was written in letterform and sent the old fashioned way, by the U.S. Mail. It had to be picked up from Southern Missouri and flown or shipped across the Atlantic to Italy; then to the Vatican. So what would be the shortest amount of time it would take that letter to get there?
<span class="break"></span>
How quickly would you think?
</p>
<p class="h-l">
H.L. Oh I imagine if you sent the letter express, global express via an international envelope perhaps 3 days, or maybe 2 days, depending on what day of the week it was and where you were at.
</p>
<p>
<span class="douglas">Douglas:</span> Very good. I checked on the internet and it says two to three days.
<span class="break"></span>
Of course I only sent the letter first class so it would have taken at least a week. But you see I paid cash. And while the killer can break into my online correspondence and possibly even into the computer system of the mail box store, where I converted the file onto paper and letter format and sent it out from, he is in the dark in regards to the method I sent it. Does that make sense?
</p>
<p class="h-l">
H.L. Yes, if you paid cash he doesn’t know if you sent it express mail or just regular first class.
</p>
<p>
<span class="douglas">Douglas:</span> That’s right. He has no idea. However the killer assumes this is an important letter to me, and it was. But again my expectations on the other end, in regards to The Popes response, were not that hopeful. I had not heard anything back from the original email I sent just a little over seven weeks before. So why rush rejection?
</p>
<p class="h-l">
H.L. It makes sense. No need.
</p>
<p>
<span class="douglas">Douglas:</span> Plus an international letter is expensive. It might have been mistaken by The Pope as me being obsessional. This was my thinking at the time.
<span class="break"></span>
But again, the killer cannot be sure. He cannot take any chances. He is going to orchestrate an event, a major event and he wants to make sure my eyes are on it, as well. In this case, while I am not his primary audience, I am at least in the audience with a front row seat and he wants to make sure I view his handiwork up close.
<span class="break"></span>
So if he waits for seven days to stage this next homicide, and I sent the letter express and it arrives at The Vatican in three days, he is out of luck. All his planning will be for not.  He will not get maximum effect, maximum impact. Does that make sense?
</p>
<p class="h-l">
H.L. Sure.
</p>
<p>
<span class="douglas">Douglas:</span> So what I am trying to say is that the killer cannot wait. He has to assume that I sent it to Rome via express mail, and therefore on the third day; on January 26, I will expect to see The Pope's reaction, perhaps a tweet, perhaps something grander in response to the correspondence that I sent out to The Vatican.
<span class="break"></span>
	So it is on January 26, when the killer assumes my eyes will be fixed to the screen of the news service or even on the television. And it is on that day, January 26th of 2020, when the killer will strike again.
</p>
<p class="h-l">
H.L. No way.
</p>
<p>
<span class="douglas">Douglas:</span> Yes it is true. And if you are any kind of sports fan or even a living breathing male in America, and I know you are both, well then you know what tragic event occurred on January 26, 2020; Kobe Bryant died in a helicopter crash.
</p>
<p class="h-l">
H.L. That can’t be true.
</p>
<p>
<span class="douglas">Douglas:</span> Now please out of respect to Kobe Bryant and to the readers, please hold off your reactions, because if you do not then I will never get through this. And if I never get through this, none of it is going to make any sense.
</p>
<p class="h-l">
H.L. Ok. I will. In fact I have to admit in some ways I saw this coming when you talked about the helicopter crash with the Clines.
<span class="break"></span>
In the same breath, thinking it could be possible and actually hearing it come from someone’s mouth is something altogether different. I am devastated. Any wounds that were starting to heal in relation to his death have now been ripped right open!
</p>
<p>
<span class="douglas">Douglas:</span> I understand. I don’t, I can’t, but I do.
</p>
<p class="h-l">
H.L. Ah, this is going to be hard. Why?
</p>
<p>
<span class="douglas">Douglas:</span> Just put your nose down in work, it is all you can do.
</p>
<p class="h-l">
H.L. This is so horrible; do you know what you are saying?
</p>
<p>
<span class="douglas">Douglas:</span> I do, my friend I do. Just take a minute.
<span class="break"></span>
<br />
<span class="bold">(One Hour Later)</span>
</p>
<p class="h-l">
H.L. So I will summarize events; the serial killer has carefully camped himself out amongst the Democratic or Liberal Elite. But you say he is not interested necessarily in forwarding their agenda. But this is his camouflage, not only to others but to himself.
</p>
<p>
<span class="douglas">Douglas:</span> That’s very accurate.
</p>
<p class="h-l">
H.L. So on the first serial murder; of the ones we are covering, they are symbolically personal. They are against Barry Sherman and his wife, both Canadian Billionaires. As you say here he is symbolically striking out against his mother and his father. He then has the bodies arranged to sit and lay in position that is one he witnessed in his childhood.
</p>
<p>
<span class="douglas">Douglas:</span> That’s right; he is going to make his parents listen. Obviously they did not listen to him and something happened to him or to his family during his childhood. The belts around their neck, perhaps they symbolize the belt he was beat with as a child. Or it could be that the killer feels they have taken all of his air, his oxygen, and he can’t breathe.
</p>
<p class="h-l">
H.L. In the second murderous rampage, he stages this as an accident. This one, against Christopher Cline is more systematic and more political. However, he is also attaching his signature to the crime. He is interested in targeting father and daughter. But why?
</p>
<p>
<span class="douglas">Douglas:</span> We will get into that. Keep going.
</p>
<p class="h-l">
H.L. Also of importance on the Cline murder, I think at least, and you agree, is the date of July 4, 2019. This date is obviously patriotic and is intended to impress someone who I am guessing is probably involved in the government or in politics.
</p>
<p>
<span class="douglas">Douglas:</span> Well yes; at the very least, the killer wants his audience to know he is an American. Remember, his first murder was in Canada, and now the Bahamas.
<span class="break"></span>
Perhaps he has done such a good job that no one knows his country of origin. He wants credit for his work. He simultaneously wants to be recognized and also remain in disguise; his mind is splintered.
</p>
<p class="h-l">
H.L. You will have to take over with Kobe. I can’t do it!
</p>
<p>
<span class="douglas">Douglas:</span> I will.
<span class="break"></span>
So here is what the killer knows about Kobe Bryant’s and my life that neither one of us paid much attention too. Here are the things, the uncanny parallels that the killer harvests out of our life, to proudly display in front of the individual he primarily is trying to impress.
<span class="break"></span>
First, our killer knows that my family has its origin in Southern Italy; Calabria. He also knows that Kobe Bryant lived as a child in Italy, in Calabria.
<span class="break"></span>
Second; he knows that of all the NBA players, of all the 10,000 Legacy Letters sent out I only sent out one to a basketball player, and that was to Kobe Bryant. Now here I need to clarify, because some of the CEOs or members of boards of directors had previously been in professional sports in their youth. But as far as a basketball player, as a superstar, as an entity of himself, there was only Kobe.
</p>
<p class="h-l">
H.L. That is uncanny.
</p>
<p>
<span class="douglas">Douglas:</span> Not only is it uncanny, but it is convincing. In fact, to all the insiders; the political and financial elite who know about <span class="italic">The Legacy Letter</span> and the cover-up already, the men and women who already knew what I was going to write and the content of this interview before we began it, this fact is extremely convincing. For them, just knowing that the only NBA player to receive this letter was Kobe Bryant and he died in an ‘accident’, is going to ring all the alarms in their highly intuitive political minds.
</p>
<p class="h-l">
H.L. I imagine. I could see that.
</p>
<p>
<span class="douglas">Douglas:</span> But here is where coincidences dip beyond the bizarre and no longer become coincidences; here is where our killer really does his homework. You see the very church that Kobe is going to attend in Newport Beach; the very church where he will attend early morning mass just hours before he is killed is called Our Lady Queen of Angels. It is a Catholic Church.
</p>
<p class="h-l">
H.L. I knew that yes. But the relevancy?
</p>
<p>
<span class="douglas">Douglas:</span> I used to work at that exact church.
</p>
<p class="h-l">
H.L. That can’t be. It is in Newport Beach.
</p>
<p>
<span class="douglas">Douglas:</span> It is true. When I was in college, I attended Orange Coast College in Costa Mesa, during my first year after high school. It was also my first year living away from home. I lived on Balboa Island just down Jamboree Street from this Church.
<span class="break"></span>
On our college job board at O.C.C. was a position for head coach of their flag football team for young kids. I applied and was offered the job, of course I accepted. I had to quit that job before too long because I needed to work full time, and it conflicted with school and my other job. But I really enjoyed it when I was there. You see there is a Catholic School connected to the Church.
</p>
<p class="h-l">
H.L. That is certainly hard to fathom, this ‘coincidence’.
</p>
<p>
<span class="douglas">Douglas:</span> Yes it is. In fact, it is just too uncanny to even be a coincidence. I had even forgotten about the job, this was 1983. Obviously Kobe would have no real way of knowing this either or any interest for that matter, but our killer did.
<span class="break"></span>
	Also, of importance here is that the following week, the week after Kobe’s death, a Catholic Bishop from Orange County, which includes Newport Beach and Kobe’s Church, was going to be at the Vatican and meeting with The Pope on unrelated though scheduled matters.
<span class="break"></span>
Therefore it is the killer’s intention that the Bishop delivers the news to The Pope; deliver the sorrow and sadness from Southern California directly to the doorstep of The Holy See.
</p>
<p class="h-l">
H.L. Everything was planned.
</p>
<p>
<span class="douglas">Douglas:</span> Yes it was, to perfection.
</p>
<p class="h-l">
H.L. I agree, we have exceeded chance and coincidence here. But why go through all of this trouble, what statement was the killer making?
</p>
<p>
<span class="douglas">Douglas:</span> That is a very good question. I can answer the first part now and then maybe the second part of it will reveal itself as we work through this.
<span class="break"></span>
You see, the killer has an apprentice. There is another, younger man who has often been connected with this man’s name. And while this younger man has killed, or had killings done for him in the past, he was sloppy about it. So our serial killer is training him; teaching him, and yes, showing off in regards to the exact precision that a murder has to be undertaken.
<span class="break"></span>
	Our killer is also applying his signature. Just like the previous helicopter crash there is a father and daughter on board. In both cases they were the daughter of the intended victim.
<span class="break"></span>
Also as you have seen with The Corona Virus, this action is directly intended to be felt within the Catholic Church. This third crime, in many ways is indirectly a hate crime against The Catholic Church.
</p>
<p class="h-l">
H.L. But all this showing off, all these clues and parallels, it makes it easier to get caught.
</p>
<p>
<span class="douglas">Douglas:</span> This is a serial killer, in his case a large part of him is crying out for help.
<span class="break"></span>
He wants to get caught, or at the very least be suspected. In the past, as we have seen he has painstakingly executed murders and no one even suspected him. In this case he is reaching out, likely to me, to put the puzzle together and to show the world his masterpiece of murder.
</p>
<p class="h-l">
H.L. Say what you want about me, just as long as you say something.
</p>
<p>
<span class="douglas">Douglas:</span> That is exactly it. You see we are dealing with a financial giant, a meticulous mind that plans everything down to the last detail. This is no slouch, far from it. He begins where other serial killers have left off. This is what happens when a great financial mind enters the arena of serial killers. As I said, in some cases it worked against him. He was too good at it. So in this case he makes so many parallels so many coincidences that are not coincidences that someone, myself, is compelled to call him out on it.
<span class="break"></span>
This is no Ted Bundy who wants to be a lawyer. This is no John Wayne Gacy who ran a part time construction business. No, this man is already successful, wildly so. There is nothing he wants that he does not get. However he witnessed something during his formative years so horrific that it has permanently warped him and pushed him over the edge.
</p>
<p class="h-l">
H.L. Can I ask why you chose Kobe Bryant over all the other basketball players to send a copy of ‘<span class="italic">The Legacy Letter</span>’ too?
</p>
<p>
<span class="douglas">Douglas:</span>  Yes, well I was afraid you were going to ask that. This is going to be very tough for me.
</p>
<p class="h-l">
H.L. Take your time.
</p>
<p>
<span class="douglas">Douglas:</span> I am so fucking sick of crying. It is so embarrassing.
</p>
<p class="h-l">
H.L. It’s okay just let it out. Everyone cries.
</p>
<p>
<span class="douglas">Douglas:</span> I’m falling apart. I can’t do this, not right now.
<span class="break"></span>
<span class="break"></span>
<span class="break"></span>
<span class="break"></span>
<span class="bold">(Extended Break)</span>
<span class="break"></span>
<span class="douglas">Douglas:</span> Sure, and that is another good question. Especially as you know I am not the biggest of basketball fans. I am now, as you would imagine, out of respect to this man, I will be the rest of my life.
<span class="break"></span>
I think there were a variety of reasons. You know the day I heard about Kobe bypassing college and going directly into the NBA, I was sitting in the parking lot in Newport Beach waiting on a friend who was in the grocery store. I remember hearing about Kobe on the radio, on a sports station, which I never really listen to. But for some reason that day I just turned it on randomly. I remember being really interested in Kobe’s story and telling myself, I should not be interested, as I was not a big basketball fan. But I was interested. Kobe’s energy was that powerful, even then.
<span class="break"></span>
Well at the time I was living in Las Vegas; so visiting a friend in Newport Beach, I took all experience of beach life in. I remember asking myself why I ever left Southern California and especially Newport Beach. So I think whenever I heard Kobe’s name it brought back that memory of Newport Beach and that was a positive memory.
</p>
<p class="h-l">
H.L. Newport Beach is very nice. It is ironic that he ended up living there, or in the area.
</p>
<p>
<span class="douglas">Douglas:</span> Very much so, unexplainable in a way. At that time he was still a high school star in Philadelphia.
<span class="break"></span>
Also, as anyone who has lived in Holland or Europe knows that Nutella is very big over there. It is as big or close to as big as peanut butter is here in the U.S.
</p>
<p class="h-l">
H.L. So there again was Kobe on the label of Nutella.
</p>
<p>
<span class="douglas">Douglas:</span> Yes, even my Dutch children know of him, he is international in his recognition.
</p>
<p class="h-l">
H.L. Yes he is.
</p>
<p>
<span class="douglas">Douglas:</span> But mostly I think I loved Kobe why so many of us did. We watched him grow up; make mistakes, admit to those mistakes, succeed at his profession and then mature, coming full circle. He was how many of us wanted to see ourselves, fallible, yet successful.
<span class="break"></span>
I am going to need a minute.
</p>
<p class="h-l">
H.L. Take a minute if you need one.
</p>
<p>
<span class="douglas">Douglas:</span> No more questions about Kobe. Not today. Not right now. I feel so fucking responsible.
</p>
<p class="h-l">
H.L. Obviously there will be more questions on him, we will just limp through them. We will get there though.
</p>
<p>
<span class="douglas">Douglas:</span> This is so hard. To feel this go through your system; I can’t explain it, somehow it stops and stalls and plugs up everything, cutting all the way down. It is like swallowing glass or swords and having to digest them. It is so painful.
<span class="break"></span>
To have to elevate our killer this way, all the while wanting with everything in me, every barbaric bone, to rip him apart piece by piece; feeding the remainder to the pigs.
<span class="break"></span>
I know that is just what he wants me to feel, so I can’t let him win. But it hurts like hell. It really hurts. It’s just so fresh, maybe this was a mistake.
</p>
<p class="h-l">
H.L. Maybe it was. We need to finish this though. We have come too far now. I can’t stay another day.
</p>
<p>
<span class="douglas">Douglas:</span> I know. I will get it together. We will just push through the rest.
</p>
<p class="h-l">
H.L. Alright; sounds like a plan. Do you believe that Kobe was interested in investing or donating?
</p>
<p>
<span class="douglas">Douglas:</span> No, I saw no evidence of that at all. That’s another tragedy as well, at least some of it. I really never could tell at least if Kobe was interested. I certainly didn’t follow up and never called him or anything. That was reserved for businessmen.
<span class="break"></span>
You know, I don’t have to tell you how famous he was, and is. He was all over the place. My prediction or detection tool just didn’t work on people like that, people who were in the media every minute of their career. And truthfully I never had any deep feeling inside of me that he was interested at all. I never even thought he would be a fit. Again, I avoided celebrities and he was a big one.
</p>
<p class="h-l">
H.L. Well, why did you send him a copy of <span class="italic">The Legacy Letter</span> then?
</p>
<p>
<span class="douglas">Douglas:</span> I don’t know. I really don’t. I guess it was just my way of saying hello. It was my way of saying, I notice you. I notice your greatness. I just loved him like we all did, and I wasn’t even a basketball fan. It’s just so ridiculous; all of it.
<span class="break"></span>
Oh, I wish I had never sent it!
</p>
<p class="h-l">
H.L. I didn’t mean it like that; not at all.
<span class="break"></span>
I just thought maybe it had something to do with why he was targeted.
</p>
<p>
<span class="douglas">Douglas:</span> You know, I could be wrong, maybe he was interested. There were many times when I misread the cues on people. That tool wasn’t perfect, not at all. With celebrities there was always distortion and bias in my detection tool; their fame and exposure made it hard to know one way or the other.
<span class="break"></span>
I mean, certainly he must have been surprised as a player to receive it. <span class="italic">The Legacy Letter</span> wasn’t a letter players received. It was a letter for the owners of sports teams. Many of them were billionaires, and this was their letter. So he must have felt already more special than he already knew he was, when he received it. He may have asked other players about it; in fact, I have some evidence on my detection tool that he told others about it. But I can’t say for sure. I can’t say anything for sure right now!
</p>
<p class="h-l">
H.L. He was Catholic.
</p>
<p>
<span class="douglas">Douglas:</span> Yes, he was. Who knows what transpired during the final months of his life. I think he was mostly focused on his kids at the time.
</p>
<p class="h-l">
H.L. He was a good father.
</p>
<p>
<span class="douglas">Douglas:</span> That was obvious.
</p>
<p class="h-l">
H.L. Do you think it was racially motivated? Do you think he was targeted because he was African-American?
</p>
<p>
<span class="douglas">Douglas:</span> Absolutely not. In fact the killer is white, and as you have seen, he targets white people. He actually prefers killing white people.
<span class="break"></span>
No it was just those similarities and interweaves between his life and mine, this is what sealed his fate. It was a freak occurrence; one in a million.
<span class="break"></span>
And obviously, I am so very sorry.
</p>
<p class="h-l">
H.L. I am sure everyone knows that. No one could have known that by sending a letter to The Pope that any of this would have occurred.
</p>
<p>
<span class="douglas">Douglas:</span> Yes, well I feel horrible, absolutely horrible about it; words cannot express the emotions. And to try on this platform would be cheap and unfitting.
</p>
<p class="h-l">
H.L. What about the investigation? Do you think their final conclusion will be foul play?
</p>
<p>
<span class="douglas">Douglas:</span> I would have no idea on that. I have no idea how far along they are, or what the status is.
<span class="break"></span>
But you have to realize that even if they found something suspicious in the beginning…
</p>
<p class="h-l">
H.L. Sure, they are not just going to release it. In some ways that would be irresponsible.
</p>
<p>
<span class="douglas">Douglas:</span> Yes, very irresponsible. It could cause panic, tip off their leads or suspects that they are looking for them. People may be afraid to fly; basketball players could be reluctant to board planes. The list goes on and on. It just wouldn’t be wise.
<span class="break"></span>
And again, our killer is very experienced at this. It took a lot of nerve to go into Southern California and pull this stunt. So it was well planned, and with experience and planning, well this only makes the job more difficult for the investigators.
</p>
<p class="h-l">
H.L. Then there would be the public’s reaction.
</p>
<p>
<span class="douglas">Douglas:</span> Exactly and this is the killers biggest shield. It has been the shield for the Liberal Elite every single step of the way; creating an impossible narrative. It is a narrative no one wants to explain. But the only way for it to make any sense is if it all comes out.
</p>
<p class="h-l">
H.L. Do you think they will catch him and prosecute him?  Do you think he will receive justice?
</p>
<p>
<span class="douglas">Douglas:</span> Well, those are two distinct questions.
</p>
<p class="h-l">
H.L. I am sorry, you are right. I just realized that.
</p>
<p>
<span class="douglas">Douglas:</span> Do I think he will ever be prosecuted? No, but I could be wrong. Because the middlemen involved will all be dead if they are not already. This will especially be true for the mechanic or whoever sabotaged or brought that chopper down. I will bet a year’s earnings he is dead already. And those in between the killer and saboteur will be joining them shortly six feet under. There will be no direct link. They might be able to prosecute him in another court, Canada or for the murders in the Bahamas. But…
</p>
<p class="h-l">
H.L. But what?
</p>
<p>
<span class="douglas">Douglas:</span> Well, the second part of the question. Will he receive justice?
<span class="break"></span>
Yes, he will receive justice.
</p>
<p class="h-l">
H.L. How?
</p>
<p>
<span class="douglas">Douglas:</span> Fate will always find a way.
</p>
<p class="h-l">
H.L. So who is it? Who is this killer, the serial killer we have been following and dogging his trail for what seems like forever?
</p>
<p>
<span class="douglas">Douglas:</span> I need a minute to take a deep breath first. We just plowed through a bunch of pain.
</p>
<p class="h-l">
H.L. Go ahead.
<span class="break"></span>

</p>
<p>
<span class="douglas">Douglas:</span> That was the hardest part. If you know how many times I have rehearsed that. And each time it never got any easier. The rest will be a cake walk.
</p>
<p class="h-l">
H.L. Are you ready? To identify the killer?
</p>
<p>
<span class="douglas">Douglas:</span> Yes, the best I can do is to reveal that I can tell you with 75 or 80 percent certainty as to who it is. But I am, inside of me, almost hundred percent sure it is this person.
</p>
<p class="h-l">
H.L. Almost?
</p>
<p>
<span class="douglas">Douglas:</span> Yes, almost, it’s the best I can do. At the same time I am vehemently against releasing this name. It is opposed to everything that defines me. It is perhaps the most irresponsible thing I have ever done; some half-ass court, trail and verdict on a public platform as this.
<span class="break"></span>
Still I am not going to disappoint the readers, as we have come this far. And this is a part of the interview now, so I can’t really turn back.
<span class="break"></span>
Also, I also know that this guy is slippery, and this is the only way, by releasing his name, he will see justice in any form.
<span class="break"></span>
Plus, I really just don’t care anymore. This is what happens when you a back a man into a corner and take everything from him.
</p>
<p class="h-l">
H.L. No, I absolutely understand your reservations. But before you release his name I have one final question to ask. Are you sure, in the case of Kobe Bryant’s accident, it was not an accident? Are you 100 percent certain?
</p>
<p>
<span class="douglas">Douglas:</span> Yes, of that I am a hundred percent sure.
<span class="break"></span>
Think about it. Think about it for a minute what I am saying. Think about all the work we have done here. Think about my life. I have made one of the largest intellectual discoveries in the history of civilization; period. Do you think I am going to risk it all to speculate on a helicopter crash?
</p>
<p class="h-l">
H.L. I can’t imagine.
</p>
<p>
<span class="douglas">Douglas:</span> No, I would never do that. But all the pieces fit so tight that they can never become untangled. I have nothing to gain and everything to lose by disclosing this. In fact we both do.
</p>
<p class="h-l">
H.L. That is very true.
</p>
<p>
<span class="douglas">Douglas:</span> I obviously have grave reservations in regards to even mentioning an event like this, tragic as it is, within a work such as we are accomplishing here.
<span class="break"></span>
An event that will likely be subject to sensationalism due to the notoriety and love bestowed on this cultural icon; the love bestowed on Kobe.
<span class="break"></span>
This, as you would imagine is everything that I want to avoid; yet it is more than that. It is diabolically opposed to my personality and to everything I believe in as an artist. I can’t stand self promotion. I am uncomfortable in marketing and as I have disclosed, am a very shy and private person. Still, this is a man and a child; ultimately it is many men, women and children, who have become prey to this killer, and they all deserve justice. So while on one hand, in my selfish moments I do not want this work to be overshadowed; on the other hand, I want to do the right thing.
<span class="break"></span>
Doing this all the time knowing I will likely face criticism and be accused of the very thing I am against.
</p>
<p class="h-l">
H.L. I can see your point. You are concerned you will be accused of sensationalism, which you are convinced is now going to happen because of the stature of Kobe Bryant. All the while you would like to not even include it because it can overshadow the rest of the work. Yet people will accuse you of trying to get mileage off this tragic event.
</p>
<p>
<span class="douglas">Douglas:</span> That is it. And it is a tragic event that on a professional level, as an artist I do not even want to include. But because of my indirect involvement in the events, I cannot suppress it. I cannot be worried about what others think, but…
</p>
<p class="h-l">
H.L. But of course you are. You are human, and we all care what others think. We all want to be accepted and want approval, like you said on the first day; no matter what anyone says. Also, you put a large amount of work into this.
</p>
<p>
<span class="douglas">Douglas:</span> We both did.
</p>
<p class="h-l">
H.L. This is true. All this work is for not; because it will only be remembered as the interview or narrative that solved Kobe’s murder.
</p>
<p>
<span class="douglas">Douglas:</span> Yes, this is my fear. I know some people want to be read at all costs, and will say and do anything to get read. I try and respect that, I try and understand that. But it is just not me. It has never been me. So I think I fear that criticism the most.
</p>
<p class="h-l">
H.L. Well once you let it go, you let it go. You know how it works.
</p>
<p>
<span class="douglas">Douglas:</span> Yes, in a way I know; I am learning at least.
</p>
<p class="h-l">
H.L. You are.
</p>
<p>
<span class="douglas">Douglas:</span> It would be sinister to hold this back, it would be sick. So I suppose in some ways, it was never an option to leave this out. To think about myself above others, about people who were murdered.
<span class="break"></span>
This was my silence in all the moments over the previous five days. I was just so excited in what we were doing, I lied to myself that I wouldn’t include this. But in the end…
</p>
<p class="h-l">
H.L. In the end, murder and death top everything. I see now why you kept it till the very last. I see why you kept it from me as well. There is nowhere to go after this.
</p>
<p>
<span class="douglas">Douglas:</span> Nowhere.
</p>
<p class="h-l">
H.L.  So let’s catch this creep so we can get out of here.
</p>
<p>
<span class="douglas">Douglas:</span> Sounds good.
</p>
<p class="h-l">
H.L. Still something is really bothering me though. Who kills kids? Who can kill a 13-year old girl, one who is so enamored with her father? That is such a spiritual bond like we talked about.
</p>
<p>
<span class="douglas">Douglas:</span> A sick fuck is who can do that. But me standing here practicing profanities on him is not going to solve the problem.
</p>
<p class="h-l">
H.L. True.
</p>
<p>
<span class="douglas">Douglas:</span> What is going to help is to take a look and find out why a grown man, an elderly grown man can push the button that executes a young girl and her father and all the innocence that represents.
<span class="break"></span>
Remember people do not become monsters on their own. And it is very rare when a killer has only organic issues with no outside influence; completely Nature and not lack of nurture. No, as you will see this killer experienced some horrors that will dwarf the nightmares experienced by all the others we examined combined.
</p>
<p class="h-l">
H.L. So who is it?
</p>
<p>
<span class="douglas">Douglas:</span> All right. You ready?
</p>
<p class="h-l">
H.L. Yes, it is getting late.
</p>
<p>
<span class="douglas">Douglas:</span> Wait, I am not sure.
</p>
<p class="h-l">
H.L. What do you mean you are not sure?
</p>
<p>
<span class="douglas">Douglas:</span> I want to explain something first about me. I need to share with you a quick story.
</p>
<p class="h-l">
H.L. Oh come on. It is obvious you are stalling. Story time is over. Let’s get this finished so I can get out of here. Let’s go now.
</p>
<p>
<span class="douglas">Douglas:</span> Just one quick story and I will reveal his name. It’s important, in fact it is necessary. Just indulge me one last time, we are almost done.
</p>
<p class="h-l">
H.L. There is just no time.
</p>
<p>
<span class="douglas">Douglas:</span> There is time, as there is another reason that this is important. I don’t want to take you or the readers into the end of this with the other stuff, the tragedy too fresh. Also, I will do a much better job if I calm down, and this story will calm me down. Trust me on this.
</p>
<p class="h-l">
H.L. Make it quick.
</p>
<p>
<span class="douglas">Douglas:</span> Thank you. We have talked a good deal about fathers in this interview. While in private we have also talked about your father and what he means to you.
</p>
<p class="h-l">
H.L. That’s true, we have.
</p>
<p>
<span class="douglas">Douglas:</span> In some ways I feel because my father has passed, I have elevated him a little more than I should have. I think many of us are guilty of this. But in some ways, I especially think I am.
</p>
<p class="h-l">
H.L. Sure, you only want to remember the good. What’s going on?
</p>
<p>
<span class="douglas">Douglas:</span> No, you’re right. We only want to remember the good. Certainly you only want to present the good, especially after they are gone. It seems disrespectful any other way.
<span class="break"></span>
But my father also had problems. In fact he had a big one and he never really got over it. He was a compulsive gambler. This is of course why we moved away from Las Vegas to Southern California when I was just four years-old. While I do not remember it personally, the stories around my family were rampant about his addiction; no groceries in the refrigerator, cashed paychecks that never made it past Fremont Street and my grandfather hunting my father down in the casinos to summon him home and dry my mother’s tears. This was our life, this was our hell.
<span class="break"></span>
So when I was going to move from Southern California, Newport Beach in fact, to Las Vegas for my second year of college, my father tried to talk me out of it. At the time I didn’t understand why. But years later it made sense.
</p>
<p class="h-l">
H.L. Sure, he didn’t want you to fall into the trap of gambling, he felt you had a genetic weakness to gambling because you were his son.
</p>
<p>
<span class="douglas">Douglas:</span> Yes, well it was a big part of it. But I moved and I didn’t listen, as most sons treat their father’s advice. While the beach was nice, I was anonymous. And there is one thing a young man doesn’t want to be in this world and that is anonymous.
</p>
<p class="h-l">
H.L. I agree.
</p>
<p>
<span class="douglas">Douglas:</span> At least in Las Vegas I had family and connections. My grandparents had been there since the 1950s and my grandfather, before he retired, was a moderately powerful man. So I went.
<span class="break"></span>
Over the years and through five more years of college and many more of writing, I worked and made a large amount of money in the hospitality industry: in the casinos and the bars, likely I made much more than others that I worked around. But that gambling bug would always try and bite me. Ultimately however, I figured out a way to defeat it.
<span class="break"></span>
Every year, I would pick one day; typically in the spring, and on that day I would take my entire paycheck, cash it at the casinos and gamble it all away. It was as a sort of homage to my origins. When I won, as I often did, I would stay until I lost it all. I would leave my bank cards at home, and only play with what my check was. Sometimes it took a couple of days to lose it all, but I always would. It was out of my system, or at least subdued.
<span class="break"></span>
Then I would go home, and wait until a year past to repeat the process. One year I even took someone with me, though I never did that again. It was a mistake to have them see me that way, almost frothing at the mouth. I was embarrassed of that part of me. I was embarrassed of that part of my father. But it was in my genes, twisting inside of me.
<span class="break"></span>
Over the years I watched many of my friends win big money, I would indulge in their excitement with them; knowing that soon they would be in bad shape. I knew that winning was really losing. So I never gambled.
</p>
<p class="h-l">
H.L. But it worked; your method. Of course back then they did not have all the resources they do now to help compulsive gamblers.
</p>
<p>
<span class="douglas">Douglas:</span> Yes, and that is a good point. I would not recommend that method to anyone. Like you say there are now better resources out there. Now the reason I tell you all of this, to make you endure this entire story, is that I was born to be a gambler. Not just because of my father, or that I was born in Las Vegas. No, there is more. You see I was born on the 21st day of the month, a blackjack fate to say the least.
</p>
<p class="h-l">
H.L. That is unusual.
</p>
<p>
<span class="douglas">Douglas:</span> While I don’t gamble with money, I gamble with my future and that is even more tragic in some ways. What I am really saying is that what I am going to disclose next, may be that one day of the year when I lose it all. So I need to go this alone, as I don’t want to gamble with your future.
<span class="break"></span>
Throughout the entire interview I have explained what will seem like impossible events to your readers, but to me they are actually very conservative estimations of what I experienced. Being from that gaming backdrop I realize the obvious value of being careful and conservative. So while I may have only one book out in 25 years, it does not mean that I was not writing during that time, not at all. But I am extremely cautious about what I release. Anything under 95 percent chance of being correct, I throw out. I don’t like gambles and I don’t like to lose, but this one I just may. Even if I do win; in this case, winning may be actually losing.
<span class="break"></span>
You see earlier I said that this is one of the most irresponsible things that I have ever done. I want to correct that now. This indeed is the most irresponsible thing that I have ever done, for this is a man’s life and his reputation. And as sick as the man may be, I don’t take it lightly to release his name. Because as you said, once it is out there, released, it is out there, and can never really be taken back.
<span class="break"></span>
Here I am only 75 percent or 80 percent positive. While inside me I may be close to 100 percent, I could be wrong as well. These events are just too close. As you will see he was certainly in the wrong place in the wrong time. He certainly has the motives, as twisted as those are, and he certainly has the resources. Indeed I should be able to build a compelling case.
<span class="break"></span>
I will tell you that Kobe Bryant’s death 100 percent is not an accident; I can sleep easy on that tragic fact the rest of my life. It is nearly mathematically impossible for it to be anything other than murder, for reasons I have stated and more. I can also tell you the Sherman's deaths are 100 percent murder and now we all know that, even the police have verified that. But I cannot tell you 100 percent that this man is the one responsible.
<span class="break"></span>
I am not a detective, an investigator or even an amateur sleuth. This was not my interest; this is certainly not my passion. Indeed I am way over my head. By chance I ended up here, somewhere I don’t want to be. While I know a great deal, more than any man should ever know about human behavior; the behavior of criminals is something that should be better left to the authorities. So no matter how convincing my argument is for his guilt, remember as with everyone he is innocent until proven guilty. And this should be true not just in the court of law, but also in the court of public opinion.
</p>
<p class="h-l">
H.L. Okay, so are you ready.
</p>
<p>
<span class="douglas">Douglas:</span> Yes, I am ready now. I know that it was a jumbo of a disclaimer, but a necessary one.
</p>
<p class="h-l">
H.L. If you say so; this is so bizarre and painful at this point that I am not even going to try and guide it in any direction. It’s on you now. It’s all on you.
</p>
<p>
<span class="douglas">Douglas:</span> Sure, I understand.
</p>
<p class="h-l">
H.L. So take a breath and let it out.
</p>
<p>
<span class="douglas">Douglas:</span> This man received a Legacy Letter like so many others; he is a billionaire and he is very elderly. I sent him a copy of <span class="italic">The Legacy Letter</span> in August of 2014, and I never saw any evidence that he even received the letter. He was essentially a ghost. Then the month before the murders of Christopher Cline, he suddenly appeared out of nowhere on my search, on my tool and on my feed. I said okay, this is just coincidence. But he was at the wrong place at the wrong time.
<span class="break"></span>
Next when I began to piece events together with Kobe Bryant’s death. He popped up radiating guilt like no one I have ever seen before. Suddenly he was there again, my newly devoted customer. This made no sense, he made no sense. But I caught him and he knew it.
</p>
<p class="h-l">
H.L. Strike two.
</p>
<p>
<span class="douglas">Douglas:</span> Yes definitely. In many ways his was like a face that pops up out of nowhere in the middle of a dream and you want to say to the face: “What are you doing here, you’re not supposed to be here?” It was illogical; it was unexplainable and it was certainly unexpected.
<span class="break"></span>
He was somewhere he shouldn’t have been, as there was no previous link to him and Kobe Bryant and myself. This man, had not been on my site since 2019 before the other murder, and there was no other reason for him to be there now.
<span class="break"></span>
I have explained what it takes to ferret some of these men out of their hole, in his case he was down deep in there, and it was only me researching the accident or murder of Kobe Bryant that did it. Men like this are extremely disciplined. Even if something affects them deeply, they suppress it. They do not flinch. When you have that amount of money you are a master at not flinching. In this case, he flinched.
<span class="break"></span>
Also, here is where some of our work from earlier should yield some small reward. Again, when you do something long enough you get a sixth sense; it developed in relation to just about every single person that visited to my website. And this isn’t 2014, when I barely know what I am doing with the detection tool or 2015 or 2016, when I am getting better at my craft and exposing the origins of Spygate. It is not even 2018 when I am testing my technique and tool in ways unimaginable for accuracy and precision. No, this is 2020 and I am a master at interpreting this data.
</p>
<p class="h-l">
H.L. I see that. You have shown me unbelievable things with that tool.
</p>
<p>
<span class="douglas">Douglas:</span> Yes, I am proud of it, as there is a purpose for it now.
<span class="break"></span>
So when this man, our killer popped up, he was thick with guilt. He was caught. I knew it and he knew it. He was somewhere where he shouldn’t have been, now twice in a row. Let’s just say this; while there is a 25 percent chance I am incorrect, in my mind there is a 1 in 1825 percent chance that I am wrong. Those are odds I will have to live with.
</p>
<p class="h-l">
H.L. So who is it? Who is the serial killer?
</p>
<p>
<span class="douglas">Douglas:</span> While his name is a bit of a cliché, the shoe fits. His name is George Soros.
</p>
<p class="h-l">
H.L. Actually, while I shouldn’t be, I am a little shocked.
</p>
<p>
<span class="douglas">Douglas:</span> Shocked is a good word. I was stunned, as well.
<span class="break"></span>
	An anarchist? Okay. I guess I could see that.
<span class="break"></span>
A Liberal Elite? Yes, I have heard the rumors. I get it.
<span class="break"></span>
But a serial killer? Not in a hundred years. I would have bet heavily against that one. But yes it is him, it is George Soros and he is guilty; he is caught. He is behind the death of The Shermans, the Clines and Kobe Bryant and his daughter. He is our serial killer. And we are going to explore how he transformed from a world class businessman into a seedy serial killer.
</p>
<p class="h-l">
H.L. I guess I am still in shock.
</p>
<p>
<span class="douglas">Douglas:</span> I agree. He just doesn’t seem like the type. George Soros was invisible to me for years, I was really surprised. I know he is the butt of a lot of conspiracy theories and so forth, but I just dismissed them as rubbish. It is important to note that I never had anything against George Soros. I liked most all the billionaires,        both politically right leaning and left leaning. It did not matter. I knew very little about Soros, but what I did know I did not dislike, and never ever for one minute suspected him behind any of the events over the last six years. Obviously if I did he would have been well covered over the last five days.
</p>
<p class="h-l">
H.L. You are sure.
</p>
<p>
<span class="douglas">Douglas:</span> Well we have been over that, but inside of me, I am almost positive; he has been hiding in plain sight. Of course, once I began to look into his childhood, and read between the lines, it was all there. Then it was obvious. But I just never would have gone there with him to begin with. I just would have never suspected.
<span class="break"></span>
Of course it is embarrassing as well. Let’s put it this way, I would have never made it as a profiler in the FBI because I caught him by complete accident. He wasn’t even in the direction I had envisioned. I was fully caught off guard.
</p>
<p class="h-l">
H.L. As if this interview can get any stranger.
</p>
<p>
<span class="douglas">Douglas:</span> Really, I agree. Here I am enamored with billionaires, almost worshipping them, and one is murdering my readers. You cannot make this stuff up, as I said.
<span class="break"></span>
And while I am embarrassed by my lack of perceptive skills, and complete inability to profile him initially; at the same, as you imagine I am extremely proud of my little detection tool I created. It solved the mystery.
</p>
<p class="h-l">
H.L. Who would have thought?
</p>
<p>
<span class="douglas">Douglas:</span> Yes, all those hours when I figured I was just feeding the bottomless pit of my lack of self-esteem, I was actually guided by fate; practicing to catch this guy, completely unconscious of my true intentions.
<span class="break"></span>
You start out doing one thing, you think you are driving and know where you are going. You don’t have a clue. You’re not driving life at all, it is driving you. What a strange journey it has been.
</p>
<p class="h-l">
H.L. I think that is what fascinates so many people about serial killers; they look just like everyone else, they act like anyone else. They are essentially chameleons, but then behind the façade: killers.
</p>
<p>
<span class="douglas">Douglas:</span> Yes, and I only have him for three events, and under 20 murders. He is in his eighties. He could have been actively killing for 50 years. As I only focused on his murders related to The Theorem, and to <span class="italic">The Legacy Letter</span>.
</p>
<p class="h-l">
H.L. It is scary.
</p>
<p>
<span class="douglas">Douglas:</span> Yes, but all those billions of dollars and all those high tech tools to conceal his searches and his vanity will reveal him in the end. He leaves crucial DNA evidence and he doesn’t even know it. I got him!
</p>
<p class="h-l">
H.L. Good job.
</p>
<p>
<span class="douglas">Douglas:</span> Yes, and when we prosecute his case, the star witness will be his damaged childhood; the horrors of WWII, his father and Adolf Hitler himself. For we are going to back to a past so dark that the child splinters into many different pieces, and then the boy grows up to avenge and ultimately mimic his origins.
</p>
<p class="h-l">
H.L. I see.
</p>
<p>
<span class="douglas">Douglas:</span> In overview, this is just another casualty of World War II. In our quest to keep man alive longer, sometimes we forget that Nature has her own idea for our allocated lifespan; as this relic has done nothing but cause misery to those around him for many years.
<span class="break"></span>
While it will be sad to see the real heroes and survivors of WW2 perish, the extinction of these fossilized dinosaurs like Soros who act out their pain instead of swallowing; well, it will be welcomed.
</p>
<p class="h-l">
H.L. Perhaps some of the readers are not acquainted with who George Soros is?
</p>
<p>
<span class="douglas">Douglas:</span> Yes, of course.
<span class="break"></span>
Every man deserves a biography and he will get his here.
<span class="break"></span>
George Soros is a true old-timer. He is 89 years-old and was born in Budapest, back when it was a monarchy; The Kingdom of Hungary. He was just an adolescent when the Germans occupied Budapest, and as we shall see he witnessed many horrors of Nazi regime during their occupation of his birthplace.
<span class="break"></span>
	After the war he drifted, as many young men do. He decided to study philosophy in London. Eventually after a stint as a railway porter; a waiter and as a clerk at a souvenir shop, he started working in the financial services industry. Ultimately, after learning to trade currencies he set up a hedge fund; he became wealthy, very wealthy at this undertaking. In 2017 he was listed as the 29th richest person in the world and the 19th richest in the United States, with an estimated net worth of 25 billion dollars. He has been convicted for insider trading in France, and is disliked by the leadership of many European countries; where he is seen as an opportunist and manipulator of both politics and currencies.
<span class="break"></span>
Of course that is the sanitized version. But behind the wiki there is much more as we will soon learn. On a personal level I really never felt any animosity towards him as I said, in fact quite the opposite. I knew he had studied philosophy and since my father was a philosopher, I would have viewed him in an elevated light. Of course, if I had any interest in international politics and had accomplished any detailed reading on him, I imagine that light would have dimmed quite quickly.
</p>
<p class="h-l">
H.L. The last of the bad guys, the really bad ones at least?
</p>
<p>
<span class="douglas">Douglas:</span> Let’s hope so. Let’s really hope so.
<span class="break"></span>
Of   course it wasn’t always like that though, he wasn’t always this way.
<span class="break"></span>
Like Bill Clinton and Barack Obama, George Soros also suffered an impossible childhood. In his case however it wasn’t so much of what happened to him, as what didn’t happen.
</p>
<p class="h-l">
H.L. What do you mean by that: What didn’t happen?
</p>
<p>
<span class="douglas">Douglas:</span> Well, his father, Tivadar Soros, was not only anti-Semitic but was also a well known retailer of forged documents during the war. Often he would charge those that were wealthy, up to twenty times the going rate for forged documents, profiting nicely off the transaction. His father even wrote a book about it afterwards; of course changing a few key facts to rewrite himself as some type of humorous hero. Though this wasn’t how George Soros remembered him at all, nor the Jewish inhabitants of Hungary or the Germans for that matter.
<span class="break"></span>
No, his father was an opportunist who profited off of others misery and even laughed and joked about it. But I can guarantee you that to the 400,000 Hungarian Jews that were sent to Auschwitz or to the half a million Hungarian Jewish Citizens that died in The Holocaust, they would not find Tivadar Soros’s sense of humor funny at all.
<span class="break"></span>
The only two Holocaust survivors I ever met did not think anything about the experience was comical.
</p>
<p class="h-l">
H.L. No kidding. It was unimaginable and horrific, nothing to write a humorous book about for sure.
</p>
<p>
<span class="douglas">Douglas:</span> But again, George Soros is only a kid, and what can a kid do in that situation but to try and survive; and to please your parents in one of the most logical ways to do that. But how do you please someone you despise the cowardice of? It is hard. He hated his father for who he was and more importantly for who he wasn’t.
</p>
<p class="h-l">
H.L. I imagine.
</p>
<p>
<span class="douglas">Douglas:</span> The adult George Soros at least went through the motions of trying to get better, as we talked about earlier; many do. He was in therapy for years trying to deal with his father issues; his simultaneous love and hate for the man. But like I said a good portion of the psychological community doesn’t have a clue as to who they are, and another good percentage hasn’t even lived enough of life to counsel anything of value.
<span class="break"></span>
For example, how is a freshly minted psychotherapist, bright and shiny out of college going to deal with Soros? How are they going to deal with the fact that even when the Russians had rescued the Jewish Faithful in Hungary, still George’s father makes his son help a German soldier safely escape from their residence. Not until after Tivadar offered him cigarettes and compassion. Meanwhile young George is crying his eyes out, because he knows what the German soldier represents; he has seen the horrors of ghetto. He realizes his father has been playing God by deciding who goes to the concentration camps and who does not; who will live and who will die, all under the close supervision of the Germans and the Hungarian turncoats aligned with the Nazi regime.
</p>
<p class="h-l">
H.L. Did that really happen?
</p>
<p>
<span class="douglas">Douglas:</span> Yes, it was in the book his father wrote. And that is likely the sanitized version; imagine what the real version of the story was and what impact that had on the young Soros? They might have given the German soldier a meal, maybe let him stay a few days. Who knows? It is locked in the subconscious of George Soros with the simultaneous attraction and repulsion to his father and his childhood horror.
</p>
<p class="h-l">
H.L. Sometimes it is better to die a hero than live as a coward.
</p>
<p>
<span class="douglas">Douglas:</span> Exactly, and that is what George Soros dealt with his entire life. He tries to find some value in survival, but all he can find is shame and embarrassment.
</p>
<p class="h-l">
H.L. So he hopes in death, in peddling death he can find some honor.
</p>
<p>
<span class="douglas">Douglas:</span> That is right. And like many children do, he followed in his father’s footsteps; in this case it is profiting from the crisis and suffering of others. That is how George Soros made all of his money.
</p>
<p class="h-l">
H.L. Exactly, he did it with currency trading in England and shorting the stock market. Wow, that is so accurate. I never connected the two.
</p>
<p>
<span class="douglas">Douglas:</span> But the problem is that those in Hungary remember him, they remember what his father did and they can see right through George Soros and want no part of him. It is the same with the vast majority of the Jewish Community; they also see right through his crisis profiteering ways. This reminds them of times when their relatives were sold out to the camps, all so people likes Tivadar Soros could save his skin and the skin of his family, lining his pockets nicely in the  process.
<span class="break"></span>
But you see Americans are not that smart. So we are easily fooled. Most of us do not have a clue as to the horrors that went on in the war. Most of us do not even travel internationally and we do it is in a safe bubble; a business meeting, honeymoon or once in a lifetime trip we take when we are too elderly to initiate any real change when we get home. I have been to Hungary, both the rural countryside and to the cities that comprise Budapest, this feeling, these words I speak; they hit you right away, like a sledgehammer when you enter the country and the cities. World War II devastated that region, and at least when I was there in 1990s the feeling was still fertile; the aura of betrayal was still radiating from the faces and on the facades of the buildings of that terrible war and purge of the Jewish Faithful.
<span class="break"></span>
There is just some history you can’t learn from the books, some you need to see, and feel and smell to understand through your secondary senses what happened once there. You need to walk onto the banks of the Danube and feel the horror as the Arrow Cross; the Hungarian regime, tied Jewish couples together and then shot  only one dead to save bullets before throwing them both still tied into the river and laughing while the dead partner’s weight sunk the still living one to their death. This isn’t fantasy, it isn’t make-believe, but it is a nightmare and it really happened. Again, there are just some things you can’t experience from books. It is so important to be there.
</p>
<p class="h-l">
H.L. Soros sees Americans as stupid, easy to deceive. It is great place to hideout in the open.
</p>
<p>
<span class="douglas">Douglas:</span> Of course he does, and in a way he is right. We are stuck in our own guilt in regards to the war, as we knew what was going on with the concentration camps long before what is recorded in the history books; we had intelligence all over the place in Eastern Europe. So Soros effectively hides around the fringes of the Jewish Community, and the Democratic Elites; he sings the song of a survivor, though he is never really at home anywhere. No one accepts him fully, because he comes from shame, from humiliation and not pride. This was his inheritance.
<span class="break"></span>
He goes and tries to recreate anarchy in distant places as it brings him closer to his father. There he can witness real men and women suffering and struggling; all the while he is locked in his past, trying to repeat it, an old vinyl record stuck in some forgotten groove. He is a wealthy, wounded, casualty of war.
<span class="break"></span>
Finally he realizes America is ripe for the taking. He has an experienced eye, is an experienced anarchist, and knows the signs to look for; a country that has become lazy and complacent, and is dominated and indoctrinated by the liberal media. A country where anger of child toward parent can be exploited and cashed in; thus pointing their angst at the very institutions they should be embracing. He has seen it all before. Like all parasites he can detect the compromised tree where he will flourish; in this case, a Democratic Party stale and still recycling policies from the past.
<span class="break"></span>
We digest the conspiracy theories that are spoon fed to us in the cheap seats; all the while the real criminals go unpunished. This is America today, this was his new target.
</p>
<p class="h-l">
H.L. Yes and those gather around him and praise him, trying to find his secret how he made money. But the secret is right there in front of them, he makes it off the misery of others, just the same way his father did!
</p>
<p>
<span class="douglas">Douglas:</span> That is right, and when someone calls him on it, well then he runs behind the anti-Semitic defense. One of his cronies calls his opponent anti-Semitic, hoping that Soros will throw him a bone, a reward for their efforts; maybe even a stock tip or something, but he never does. He is in it for himself.
</p>
<p class="h-l">
H.L. And hiding behind the anti-Semitic diversion only infuriates the members of the Jewish Community who actually know survivors or more importantly once knew those who did not survive The Holocaust.
</p>
<p>
<span class="douglas">Douglas:</span> Exactly, so the Jewish Community wants no part of George Soros. He has to buy his way into every party. He has to pay for acceptance, and he still doesn’t get the seat he wants.
</p>
<p class="h-l">
H.L. Therefore he clings to the Democratic Elite as a last resort for acceptance?
</p>
<p>
<span class="douglas">Douglas:</span> Yes, but again, it is not a natural alliance. It is just another party he has to pay to get into. They don’t want him there.
</p>
<p class="h-l">
H.L. So he clings to Bill Clinton, because the others are too sophisticated and see right through him.
</p>
<p>
<span class="douglas">Douglas:</span> That is right, Soros sees Bill Clinton as a dumb hillbilly who will buy into his demented agenda. While Clinton is not ignorant, his pain and quenchless needs have certainly diminished his intelligence, so as you say, Soros finds a way in. He plays the role of abusive stepfather to Clinton; while Bill Clinton was focused on his female issues, his unmet male dominated needs crept in and blindsided him, slapped him straight across the face.
<span class="break"></span>
Still even Bill Clinton has had enough of Soros; now, in fear of being ideologically homeless, Soros must pull Clinton in deeper.
</p>
<p class="h-l">
HL. This is what he is doing by these events; these staged homicides that only are thinly veiled as accidents.
</p>
<p>
<span class="douglas">Douglas:</span> Exactly.
</p>
<p class="h-l">
H.L. What a legacy to leave to your children.
</p>
<p>
<span class="douglas">Douglas:</span> That’s a good point. It really is.
<span class="break"></span>
You know we have seen billionaires that plan on leaving their children little or nothing, giving all their money away to others before they go; real pieces of work.
<span class="break"></span>
But not Soros, he will leave plenty behind. He will leave perhaps one of the most infamous names in recent history; the man who killed children, who killed Kobe Bryant, who killed Chris Cline, The Shermans and many others. This is what his kids will inherent. While they may get his money, they will need it to offset the decades of shame that will be bestowed upon their lineage.
</p>
<p class="h-l">
H.L. And what about the fathers with their daughters being murdered together?
</p>
<p>
<span class="douglas">Douglas:</span> Well that is a little more complex; though it may be closer to his heart than you would guess.
</p>
<p class="h-l">
H.L. What do you mean by that?
</p>
<p>
<span class="douglas">Douglas:</span> Let’s go back to Budapest. Let’s return to Hungary. Let’s see it all again, the ghetto, the horrors. There George falls in love, it is not impossible. As we said earlier love often finds us when we are often least prepared for it. She is not a wealthy girl, but her family is devout in her Jewish Faith. Soon they will be sent to the camps. George begs his father to help them, to obtain the forged documents for the love of his life. His father refuses. Her parents simply do not have enough money. Off to Auschwitz she goes.
</p>
<p class="h-l">
H.L. So in the murder of the Sherman’s, George has the bodies placed in a position his parents were sitting and laying, as they symbolically represent them. Then they would listen to George now and his girlfriend will not be murdered at Auschwitz.
</p>
<p>
<span class="douglas">Douglas:</span> Well that is good. You are jumping ahead, and without notes of any value. But yes.
<span class="break"></span>
What I am trying to express about how can you kill a child? I would imagine the only way, or one of the only ways you could in the sickest of minds accomplish that if you have seen a child killed in front of you when you were a child yourself.
<span class="break"></span>
With that murder, or the many others he witnessed either directly or experienced indirectly, his innocence was stolen from him. The human mind, our conscious and unconscious mind is only capable of so much.
</p>
<p class="h-l">
H.L. That makes sense.
</p>
<p>
<span class="douglas">Douglas:</span> Or it could be something even closer to home, something close to his home now.
</p>
<p class="h-l">
H.L. What do you mean closer to home?
</p>
<p>
<span class="douglas">Douglas:</span> Well Soros can likely fool his sons that what he is doing has value, but something may have snapped in the relationship between his daughter and him. Perhaps she sees through him, perhaps she is suspicious of his involvement with the Sherman murders; because like George Soros saw through the hypocrisy of his father, his daughter now sees through the hypocrisy of her father.
</p>
<p class="h-l">
H.L. That would make sense.
</p>
<p>
<span class="douglas">Douglas:</span> So to destroy that relationship, to see a girl perish with her father somehow nullifies the memory of how his daughter sees him; how he sees his father. It just eats at him to see a father and a daughter happy together. I mean to him Kobe didn’t have to compromise himself to make money. He didn’t make money off of other people’s misfortune.
</p>
<p class="h-l">
H.L. Unless they were his opponents.
</p>
<p>
<span class="douglas">Douglas:</span> So true, you didn’t want to play against him. What a great player he was! Thank you for that.
<span class="break"></span>
	No, Kobe Bryant made money from displaying athletic excellence and from entertaining sports fans the world over.
<span class="break"></span>
It is the same with Chris Cline, as he made money by providing jobs to people. He made money by accomplishing something useful for society by mining energy out of the earth. But Soros has only made his money from the disruption of the well being of others, a nasty old calamity peddler. So his daughter will never look at him the same way that Clines’ daughter looked at her father, or Bryant’s daughter looked at Kobe.
</p>
<p class="h-l">
H.L. That is probably it. The motive fits.
</p>
<p>
<span class="douglas">Douglas:</span> But the motive may not even be as deep as that. This could be a message to Obama and Clinton, who both have daughters. George Soros is telling them they must conform and continue to indulge his sickness or they will perish together with their most valued possessions.
<span class="break"></span>
For those around him, around Soros, there is no escape now.
<span class="break"></span>
Soros is sick and desperate; it is hard to fathom what bizarre signals his tangled limbic system is pushing up to the surface, comingling with his conscious observations and spinning into unpredictably tragic motivations and actions.
</p>
<p class="h-l">
H.L. Sick indeed.
</p>
<p>
<span class="douglas">Douglas:</span> George Soros is a man broken by his own past, misery seeping from his pores. He is a testament to toxicity. Take a good look at his ghostly appearance and you can see the display of 80 plus years of poorly managed pain. It should certainly motivate no one. That is not success. That is failure.
</p>
<p class="h-l">
H.L. That makes a lot of sense. No matter how much money he has, he can’t purchase happiness within himself.
</p>
<p>
<span class="douglas">Douglas:</span> No he can’t, and while he can purchase many houses he can’t purchase a home; a group that will accept him. Even the Democratic Elite has to hide him in the corner, as they are embarrassed of him. And that is hard to deal with for fifty or sixty years. So he is reaching out for unconditional love from them in a very sick and distorted way. He is trying to earn his value. He feels himself slipping away, as people are waking up. So he has to resort to more and more brutal tactics to keep them interested in him.
</p>
<p class="h-l">
H.L. What about the Shermans? What was the subconscious force behind their murder?
</p>
<p>
<span class="douglas">Douglas:</span> Well, earlier you likely solved part of the mystery yourself, but he started at the beginning. It was an orgiastic release of his contempt for both his father and his mother.
</p>
<p class="h-l">
H.L. Yes, that makes sense.
</p>
<p>
<span class="douglas">Douglas:</span> It was the initial explosion. It was personal and had to do with Barry Sherman’s Jewish Beliefs, and contrasting actions. While Barry Sherman was raised within the Jewish Faith, he on a personal level was an atheist. He simply saw too much of his father in Barry Sherman. He saw in Mrs. Sherman his symbolic mother and punished her for going along with her husband, for saying nothing, and for not listening to young George and his budding morality. Therefore Soros will have them both killed, the executed punishment for their ultimate betrayal of him.
<span class="break"></span>
George Soros then holds himself up as some sort of morality policeman. Perhaps that was the role he loosely assumed within his family. The role he assumed during his childhood, in the tragedy of those impossible conditions. He feels he is obligated to purge then the world of those with imperfections; in Barry Sherman he sees an exploitation of the Jewish Faith, barely noticeable if even existent to others, but exaggerated in his eyes. In Chris Cline perhaps it was the divorce, in Kobe perhaps the infidelity.
<span class="break"></span>
We are all human and we all error, but perhaps he who made the most egregious error is Soros’s father. Tivadar Soros naively assumed that escape was indeed escape, but everyone is different, every child is unique. And the fragile morality and faith that held young George together as a child was splintered into pieces by his father’s actions.
<span class="break"></span>
I once read that science is based on the majority, not the exceptions. I couldn’t agree more with that assessment. This however is certainly one of those exceptions. Throughout this entire interview we have dealt with patterns, childhood influences under horrific conditions. But even the best of models does not hold up under a situation such as this. As fortunately there is no real precedent to The Holocaust to draw from; mass genocide and its aftermath. Who knows the horrors of what the young George Soros realized in Budapest during the war? It is possible that he is not even sure. But others witnessed dead bodies decaying in the streets of the Jewish Ghetto, frequent gunfire, rampant typhus, impossibly crowded conditions and humiliations on such a scale that they defy reality; this blanketed under the ominous and imminent threat of deportation and death. All of this begging the question: What is there to give to a child when everything is taken from you? The real and sad answer is; nothing.
<span class="break"></span>
In a child’s mind there are often heroes and villains, to the grown George Soros the heroes were those who died for something, the Jewish Faithful; the villains were those who survived for nothing, his parents. He wanted; no, he needed to expunge that memory, the survival at all cost ethos. He didn’t murder Barry Sherman for who he was, he murdered Barry Sherman for who he wasn’t; the representation of whom his father wasn’t. Somehow in the tattered mind of Soros, Barry Sherman connected all those dots; the symbol of what he did not want to become, but he himself was in the end. While we want to neatly tuck The Holocaust away in history, in the complexion of George Soros reared its ugly head and reminded us that we must never forget!
</p>
<p class="h-l">
H.L. Very powerful; the shoe then fits perfectly.
</p>
<p>
<span class="douglas">Douglas:</span> Then, very possibly, the Shermans were going to give to The Theorem in order to further the advancement of society. It just didn’t seem right to Soros, his symbolic father choosing someone else over him. He was accomplishing two goals with one act, all in the name of conservation of energy; all in the name of the contemptuous memory of his parents.
<span class="break"></span>
I doubt Soros could understand what he has done, what is at stake. While comprehension of The Theorem is beyond the mental capacity of very few, as we have seen that even a child can understand it; George Soros may be an exception. His pain has made him so nimble-minded that all he can do is to repeat the same old themes his father presented; round and round circulating in his head. He tries to make sense of them, but they make no sense. He vomits his pain onto the pages of book after book, but the words and concepts are always detoured though his impossible origins and paradoxical compassions for the man he first heard speak them. This is not an intellectual; he is trained circus performer, tired and fatigued, delivering the same old tricks to an ever dwindling audience.
</p>
<p class="h-l">
H.L. Very well said; it is all coming together now for me at least. So after the first murderous explosion with the Shermans, his thirst is still not quenched. He is crying out for help, suffering greatly and wants to make his mark. Like Obama left clues for his potential suicide, so as his actions are not to be misinterpreted, Soros puts his mark; father and daughter, on the second on the second and third acts.
</p>
<p>
<span class="douglas">Douglas:</span> That is it, you summed it up perfectly. Why do something if you are never going to get credit for it? Sure, it fills a psychological need, but with this guy, with Soros, there has to be some other prize at the end as well.
<span class="break"></span>
You know, you spend your entire life trying to forgive. You are told and taught with the principles of your faith, of your community and from your parents that forgiveness is divine. But that doesn’t sit right with many; what Hitler did was beyond irrational, it bordered on demonic. So the pain, it still consumes your body. It still pulls you down in to the water; a vast weight you can never escape. So in the case of Soros, to nullify that pain is impossible as this humiliation never goes away.
<span class="break"></span>
In this interview we have seen examples of children who grow up to avenge their father; search for their father in the faces of others, and ultimately try to forget the father that forgot about them. But in Soros’s case this mimicry of his dad is exceptionally dangerous. His father, through the decision of whom to provide forged documents for and who not to played God to the Jewish Faithful in Hungary. He could decide who would live and who would die. Now George Soros has a taste for that omnipotence.
<span class="break"></span>
He has battled inside of himself for years to not be the like the man he despised, occasionally winning, but mostly failing in defeat. However time and decay takes their toll on everyone, and now he has to pay his due. Killing in the name of politics is just killing to him now. It is a convenient excuse. Today he picks The Theorem; tomorrow it will be something else. One thing for sure, he will not stop until we stop him.
</p>
<p class="h-l">
H.L. We will stop him!
</p>
<p>
<span class="douglas">Douglas:</span> In some ways I see what the killer is doing now. I see what Soros is doing. He is envious; he feels that he could have been a great intellectual if not for the war. This is his excuse. This is his delusion. Silly man; he doesn’t seem to realize that the way to find anything of intellectual value doesn’t come from building up your own defenses, but instead arrives from stripping them down.
<span class="break"></span>
So he wants me to watch and witness the feeling of powerlessness that he experienced as an adolescent, to watch those around me being killed the way he experienced it, yet be unable to do anything about it.
<span class="break"></span>
He wants to give me enough evidence to know it is him, but at the same time he will only give me enough so that no one believes me. He will make the events so farfetched that certainly no one can fathom their likelihood. But here the killer, here Soros underestimates me and he also underestimates our readers.
<span class="break"></span>
As ultimately our advantage over him is his own festering disease, his bleak outlook on humanity of which we do not share. He sees me, he sees our readers, the way he sees the world. But while we have our moments, we are not as sour as him. Certainly while we all feel bad in some way for what he experienced, as we should, our compassion has its limits. As there are others who realized those horrific events and did not feel the need to line their pockets; instead they dove deep into their faith, into their family and their community.
<span class="break"></span>
They killed yes, but not people. They slowly murdered the shame and horror they experienced during The Holocaust by replacing it with life, with a belief in humanity that was reborn slowly with every passing day; renewed in the face of every newborn smiling infant and the promise of each consecutive sunrise. Soros, like so many killers thinks the problem is with society, but instead it is within himself.
<span class="break"></span>
Good riddance pal; you got it all wrong, so very wrong. Good riddance. Enjoy your eternal stay in hell!
</p>
<p class="h-l">
H.L. They’re overmatched. You caught them. You got them all!
</p>
<p>
<span class="douglas">Douglas:</span> I will go after them. That is one thing for sure. It’s bad luck for them to me as an opponent. You have seen how asleep I was for years, but I am awake now. Damn it, I am awake now! I am wide awake.
<span class="break"></span>
<br />
</p>
			</v-col>
			<v-col cols="12" class="text-center">
				<span class="douglas">END OF INTERVIEW…</span>
			</v-col>
		</v-row>
	</v-container>
</template>

<script>
	export default {

	}
</script>

<style scoped>

</style>